<div mat-dialog-title>
  <div style="display: flex; flex-direction: row;">
    <h2 style="flex:1 1 auto; font-family: Roboto, 'Helvetica Neue', sans-serif; width: 80%;" *ngIf="project">
      {{ project.name }}: {{ originalProjectControlItem.controlItem.complianceAreaControlId }}
      <span style="float:right" *ngIf="originalProjectControlItem.primarySource">
        <img
          [src]="'../../../assets/icon/' + (originalProjectControlItem.primarySource ? 'broadcast.svg' : 'crossmap.png')"
          height="30px" />{{ originalProjectControlItem.primarySource?.fromProjectName }}:
        {{ originalProjectControlItem.primarySource?.fromControlItemName }}
      </span>
    </h2>
    <div style="flex:0 0 auto; margin-right: 44px; font-size: 14px;" *ngIf="subItems?.length && !parentControlItem">
      <div *ngIf="levelReached">{{ levelReached }} level reached</div>
      <div *ngFor="let item of subitemSummary">
        {{ item.level }} - {{ item.completed }}/{{ item.total }} ({{ item.percent }}%)
      </div>
    </div>
  </div>
  <div class="close-icon" mat-button (click)="dialogRef.close()"></div>
</div>
<div mat-dialog-content>
  <div class="control-item-component" *ngIf='projectControlItem != null'>
    <mat-tab-group [linear]="false" class="matTab" (selectedTabChange)="resetMappingStates()"
                   [(selectedIndex)]="selectedTab">
      <mat-tab label="Summary">

        <!-- Summary Section -->
        <div class="section">
          <div style="display: flex; align-items: flex-start; gap: 20px;">
            <div style="border-radius: 5px; border: 1px solid #dee2e6;width: fit-content; margin-bottom: 20px;">
              <div class="control-div">
                <div style="display: flex; justify-content: space-between; padding: 5px;">
                  <p style="width:80px;font-size:12px;font-weight:600">Control</p>
                  <span style="font-size:12px;font-weight:600" pTooltip="Implementation Control Statement">IS</span>
                  <span style="font-size:12px;font-weight:600" pTooltip="Policy &amp; Procedures">PP</span>
                  <span style="font-size:12px;font-weight:600" pTooltip="Evidence">E</span>
                  <span style="font-size:12px;font-weight:600" pTooltip="Gaps">G</span>
                </div>
              </div>
              <div class="control-div" style="border-top: 1px solid #dee2e6">
                <div style="display: flex; justify-content: space-between; padding: 5px;">
                  <p style="width:80px;font-size:12px;font-weight:500">
                    {{ originalProjectControlItem.controlItem.complianceAreaControlId }}
                  </p>
                  <span [ngStyle]="{'background-color': originalProjectControlItem.implementationStatusStyle}"
                        style="margin-top:5px"></span>
                  <span
                    [ngStyle]="{'background-color': originalProjectControlItem.policyNotNeeded ? 'gray' : originalProjectControlItem.projectControlItemPolicies?.length > 0 ? 'green' : 'red'}"
                    style="margin-top:5px"></span>
                  <span [ngStyle]="{'background-color': originalProjectControlItem.evidencesStyle}"
                        style="margin-top:5px"></span>
                  <span
                    [ngStyle]="{'background-color': originalProjectControlItem.gapStyle === 'orangestatus' ? 'orange' : originalProjectControlItem.gapStyle || 'transparent'}"
                    style="margin-top:5px"></span>
                </div>
              </div>
            </div>
            <mat-form-field class="input-section">
              <mat-label>Implementation Status</mat-label>
              <mat-select [(ngModel)]="originalProjectControlItem.implementationStatus" name="implementationStatus"
                          (selectionChange)="implementationStatusChanged($event)"
                          disabled="{{isReadOnly(originalProjectControlItem) && !isManager}}">
                <mat-option [value]="0">None</mat-option>
                <mat-option [value]="1"
                            [disabled]="subItems.length > 0 && !allSubitemsImplemented">Implemented
                </mat-option>
                <mat-option [value]="2">Partially Implemented</mat-option>
                <mat-option [value]="3">Planned</mat-option>
                <mat-option [value]="4">Alternative Implementation</mat-option>
                <mat-option [value]="5">Not Applicable</mat-option>
                <mat-option [value]="7">Not Implemented</mat-option>
                <!--mat-option [value]="6">Ongoing</mat-option-->
              </mat-select>
            </mat-form-field>
            <mat-form-field floatLabel="always" class="input-section">
              <mat-label>Due Date</mat-label>
              <input matInput [matDatepicker]="implementationDueDatePicker"
                     [(ngModel)]="originalProjectControlItem.implementationDueDate"
                     name="implementationDueDate"
                     [disabled]="isReadOnly(originalProjectControlItem)">
              <mat-datepicker-toggle matSuffix [for]="implementationDueDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #implementationDueDatePicker></mat-datepicker>
            </mat-form-field>

          </div>
          <div style="display: flex; width: 100%; gap: 30px;">
            <mat-form-field class="input-section">
              <mat-label>Control Owner</mat-label>
              <mat-select [(ngModel)]="originalProjectControlItem.assignedClient.userId" name="clients"
                          [disabled]="isReadOnly(originalProjectControlItem) && !isManager">
                <mat-option *ngFor="let client of clients" [value]="client.userId">
                  {{ getFullName(client) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="input-section">
              <mat-label>Business Owner</mat-label>
              <input matInput type="text" name="controlOwner_" [(ngModel)]="originalProjectControlItem.controlOwner_"
                     #description="ngModel" />
            </mat-form-field>

            <mat-form-field class="input-section">
              <mat-label>Advisor</mat-label>
              <mat-select [(ngModel)]="originalProjectControlItem.assignedConsultantIdList" name="advisors" multiple
                          [disabled]="isReadOnly(originalProjectControlItem) && !isManager">
                <mat-option *ngFor="let advisor of advisors" [value]="advisor.userId">
                  {{ getFullName(advisor) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div style="display: flex; width: 100%; gap: 30px; margin-top: 10px;">
            <mat-form-field class="input-section">
              <mat-label>Frequency</mat-label>
              <mat-select [(ngModel)]="originalProjectControlItem.recurring"
                          [disabled]="isReadOnly(originalProjectControlItem) && !isManagerUser"
                          (ngModelChange)="onFrequencyChange($event)"
              >
                <mat-option *ngFor="let rec of recurringList" [value]="rec.value">
                  {{ rec.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field floatLabel="always" class="input-section" *ngIf="originalProjectControlItem.recurring != 0">
              <mat-label>Starts On</mat-label>
              <input matInput [matDatepicker]="dueDatePicker"
                     [(ngModel)]="localDueDate"
                     (dateChange)="onDueDateChange($event)"
                     name="dueDate"
                     [disabled]="isReadOnly(originalProjectControlItem)">
              <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #dueDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field floatLabel="always" class="input-section" *ngIf="originalProjectControlItem.recurring == 0">
              <mat-label>Starts On</mat-label>
              <input matInput [matDatepicker]="dueDateFakePicker"
                     readonly
                     name="dueDateFakePicker"
                     [disabled]="isReadOnly(originalProjectControlItem)">
              <mat-datepicker-toggle matSuffix [for]="dueDateFakePicker"></mat-datepicker-toggle>
              <mat-datepicker #dueDateFakePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="input-section">
              <mat-label>Recurring Instance</mat-label>
              <mat-select [(ngModel)]="selectedCompletionPeriod"
                          name="completedDatesCtrl"
                          (selectionChange)="completionPeriodChange($event.value)">
                <mat-option value="null"></mat-option>
                <mat-option *ngFor="let completionPeriod of originalProjectControlItem.completionPeriods"
                            [value]="completionPeriod"
                            [disabled]="isFuture(completionPeriod)">
                  <span [ngStyle]="{'font-weight': completionPeriod.isCompleted ? 'bold' : 'normal'}">
                    {{ completionPeriod.dueDate | date: 'MM/dd/yyyy' }}
                  </span>
                </mat-option>

                <!--mat-option [value]="customDateOption">
                  Custom Date...
                </mat-option-->
              </mat-select>
            </mat-form-field>
            <div *ngIf="selectedCompletionPeriod === customDateOption">
              <mat-form-field>
                <mat-label>Pick Custom Date</mat-label>
                <input matInput [matDatepicker]="picker"
                       [(ngModel)]="customDate"
                       name="customDate"
                       (dateChange)="onCustomDateChanged($event.value)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>

            <ng-container *ngIf="selectedCompletionPeriod">
              <div class="flex items-center mt-2">
                <mat-checkbox [(ngModel)]="selectedCompletionPeriod.isCompleted"
                              (change)="onCompletionStatusChanged($event.checked)"
                              [disabled]="isReadOnly(originalProjectControlItem)">
                  Completed
                </mat-checkbox>
              </div>
            </ng-container>

            <ng-container *ngIf="selectedCompletionPeriod?.isCompleted">
              <mat-form-field floatLabel="always" class="input-section">
                <mat-label>Actual Completion Date</mat-label>
                <input matInput [matDatepicker]="actualDatePicker" [(ngModel)]="selectedCompletionPeriod.actualDate"
                       name="actualDate" (dateChange)="onActualDateChanged($event)"
                       [disabled]="isReadOnly(originalProjectControlItem)">
                <mat-datepicker-toggle matSuffix [for]="actualDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #actualDatePicker></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="input-section">
                <mat-label>Updated in Rizkly</mat-label>
                <input matInput [matDatepicker]="completedInRizklyPicker"
                       [(ngModel)]="selectedCompletionPeriod.completedInRizkly" name="completedInRizkly"
                       [disabled]="isReadOnly(originalProjectControlItem) || !selectedCompletionPeriod.isCompleted">
                <mat-datepicker-toggle matSuffix [for]="completedInRizklyPicker"></mat-datepicker-toggle>
                <mat-datepicker #completedInRizklyPicker></mat-datepicker>
              </mat-form-field>
            </ng-container>
          </div>
          <div style="display: flex; width: 100%; gap: 30px; margin-top: 10px;">
            <div class="lastModifiedDate">
              <h3>Last Modified Date</h3>
              <p name="lastModifiedDate">{{ originalProjectControlItem.lastModifiedDate | date:'shortDate' }}</p>
            </div>
            <mat-form-field class="input-section">
              <mat-label>Workstream User Alert</mat-label>
              <mat-select [(ngModel)]="originalProjectControlItem.workstreamUserIds" name="workstreamUserIds" multiple
                          [disabled]="isReadOnly(originalProjectControlItem) && !isManager">
                <mat-option *ngFor="let user of workstreamUsers" [value]="user.userId">
                  {{ getFullName(user) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div>
              Points: {{originalProjectControlItem.dynamicScore}}
            </div>
          </div>

        </div>


      </mat-tab>
      <mat-tab label="Guidance">
        <div class="section">

          <mat-accordion [multi]="true">
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)" expanded>
              <mat-expansion-panel-header>
                <mat-panel-title> Requirements & Guidance</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Requirements & Guidance -->
              <div>
                <div style="display: flex; width: 100%; gap: 30px;">
                  <mat-form-field class="input-section">
                    <mat-label>Compliance Area Control ID</mat-label>
                    <input matInput name="controlId"
                           value="{{originalProjectControlItem.controlItem.complianceArea.name}} - {{originalProjectControlItem.controlItem.complianceAreaControlId}}"
                           readonly>
                  </mat-form-field>
                  <mat-form-field class="input-section">
                    <mat-label>Category</mat-label>
                    <input matInput name="category" [(ngModel)]="originalProjectControlItem.controlItem.category"
                           #description="ngModel" readonly />
                  </mat-form-field>
                </div>
                <div style="display: flex; width: 100%; gap: 30px;">
                  <mat-form-field class="input-section" *ngIf="isNotHiddenForComplianceArea">
                    <mat-label>Short Name</mat-label>
                    <input matInput name="shortName" [(ngModel)]="originalProjectControlItem.controlItem.shortName"
                           readonly>
                  </mat-form-field>
                </div>
                <div style="display: flex; width: 100%; gap: 30px; justify-content: space-between;">
                  <div style="width: 70%;">
                    <mat-form-field class="textarea-section">
                      <mat-label>Description</mat-label>
                      <textarea matInput rows="10" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="20" type="text"
                                name="description" [(ngModel)]="originalProjectControlItem.controlItem.description"
                                #description="ngModel">
 </textarea>
                    </mat-form-field>
                  </div>
                  <div style="width: 30%; display: flex; justify-content: flex-end;">
                    <img style="position: relative;margin-top: -81px;height: 160px;width: 81px;" width="120"
                         src="../../../assets/img/guide.png" />
                  </div>

                </div>

                <div>
                  <mat-label (click)="visibility.clarificationSummaryEdit = !visibility.clarificationSummaryEdit"
                             class="summary-Heading">
                    Clarification Summary
                    <span style="white-space: nowrap">
                      <i *ngIf="originalProjectControlItem.controlItem.clarificationSummary" class="pi pi-check"></i>
                      <span class="pi"
                            [ngClass]="{'pi-angle-down': !visibility.clarificationSummaryEdit, 'pi-angle-up': visibility.clarificationSummaryEdit}"></span>
                    </span>
                  </mat-label>
                  <div class="Summary" *ngIf="visibility.clarificationSummaryEdit"
                       [innerHTML]="addToken(originalProjectControlItem.controlItem.clarificationSummary) | sanitizeHtml">
                  </div>
                </div>

                <div>
                  <mat-label (click)="visibility.additionalRequirementsEdit = !visibility.additionalRequirementsEdit"
                             class="summary-Heading">
                    Additional Requirements
                    <span style="white-space: nowrap">
                      <i *ngIf="originalProjectControlItem.controlItem.clarificationSummary" class="pi pi-check"></i>
                      <span class="pi"
                            [ngClass]="{'pi-angle-down': !visibility.additionalRequirementsEdit, 'pi-angle-up': visibility.additionalRequirementsEdit}"></span>
                    </span>
                  </mat-label>
                  <div class="Summary" *ngIf="visibility.additionalRequirementsEdit" style="white-space: pre;"
                       [innerHTML]="addToken(originalProjectControlItem.controlItem.additionalRequirements) | sanitizeHtml">
                  </div>
                </div>

                <div>
                  <mat-label class="summary-Heading">
                    Official Guidance <span class="pi pi-pencil"
                                            (click)="visibility.supplementalGuidanceEdit = !visibility.supplementalGuidanceEdit"></span>
                    <span style="white-space: nowrap">
                      <i *ngIf="originalProjectControlItem.supplementalGuidance" class="pi pi-check"></i>
                      <span class="pi"
                            [ngClass]="{'pi-angle-down': !visibility.supplementalGuidanceExpanded, 'pi-angle-up': visibility.supplementalGuidanceExpanded}"
                            (click)="visibility.supplementalGuidanceExpanded = !visibility.supplementalGuidanceExpanded"></span>
                    </span>
                  </mat-label>
                  <div class="Summary"
                       *ngIf="!visibility.supplementalGuidanceEdit && visibility.supplementalGuidanceExpanded"
                       [innerHTML]="addToken(originalProjectControlItem.supplementalGuidance) | sanitizeHtml"></div>
                  <p-editor matInput
                            *ngIf="visibility.supplementalGuidanceEdit && visibility.supplementalGuidanceExpanded"
                            type="text"
                            name="references" [(ngModel)]="originalProjectControlItem.supplementalGuidance"
                            #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                    <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                      <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                      <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                      <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                    </p-header>
                  </p-editor>
                </div>

                <div>
                  <mat-label (click)="visibility.assessmentObjectiveEdit = !visibility.assessmentObjectiveEdit"
                             class="summary-Heading">
                    Assessment Objective
                    <span style="white-space: nowrap">
                      <i *ngIf="originalProjectControlItem.controlItem.assessmentObjective" class="pi pi-check"></i>
                      <span class="pi"
                            [ngClass]="{'pi-angle-down': !visibility.assessmentObjectiveEdit, 'pi-angle-up': visibility.assessmentObjectiveEdit}"></span>
                    </span>
                  </mat-label>
                  <div *ngIf="visibility.assessmentObjectiveEdit" class="Summary" style="white-space: pre;"
                       [innerHTML]="addToken(originalProjectControlItem.controlItem.assessmentObjective) | sanitizeHtml">
                  </div>
                </div>

                <div>
                  <mat-label class="summary-Heading">
                    {{ advisorCompany?.companyName || 'Rizkly' }} Guidance <span class="pi pi-pencil"
                                                                                 (click)="visibility.instructionsEdit = !visibility.instructionsEdit"></span>
                    <span style="white-space: nowrap">
                      <i *ngIf="originalProjectControlItem.instructions" class="pi pi-check"></i>
                      <span class="pi"
                            [ngClass]="{'pi-angle-down': !visibility.instructionsExpanded, 'pi-angle-up': visibility.instructionsExpanded}"
                            (click)="visibility.instructionsExpanded = !visibility.instructionsExpanded"></span>
                    </span>
                  </mat-label>
                  <div class="Summary" *ngIf="!visibility.instructionsEdit && visibility.instructionsExpanded"
                       [innerHTML]="addToken(originalProjectControlItem.instructions) | sanitizeHtml"></div>

                  <p-editor matInput *ngIf="visibility.instructionsEdit && visibility.instructionsExpanded" type="text"
                            name="instructions" [(ngModel)]="originalProjectControlItem.instructions"
                            #description="ngModel"
                            [disabled]="isReadOnly(originalProjectControlItem)">

                    <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                      <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                      <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                      <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                    </p-header>
                  </p-editor>
                </div>

                <div>
                  <div>
                    <mat-label (click)="visibility.exampleEdit = !visibility.exampleEdit"
                               class="summary-Heading">
                      Example
                      <span style="white-space: nowrap">
                        <i *ngIf="originalProjectControlItem.controlItem.example" class="pi pi-check"></i>
                        <span class="pi"
                              [ngClass]="{'pi-angle-down': !visibility.exampleEdit, 'pi-angle-up': visibility.exampleEdit}"></span>
                      </span>
                    </mat-label>
                    <div class="Summary" *ngIf="visibility.exampleEdit"
                         [innerHTML]="addToken(originalProjectControlItem.controlItem.example) | sanitizeHtml"></div>
                  </div>
                </div>
                <mat-form-field class="textarea-section" style="width: 300px;">
                  <mat-label>Priority</mat-label>
                  <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="1" type="text" name="category"
                            [(ngModel)]="originalProjectControlItem.priorityText"></textarea>
                </mat-form-field>


                <div>
                  <mat-form-field class="textarea-section" style="width: 300px;">
                    <mat-label>Supplemental Control Information</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" class="form-control"
                              [(ngModel)]="originalProjectControlItem.customDescription" name="customDescription"
                              #clientInstructions="ngModel" [disabled]="isUser">
         </textarea>
                  </mat-form-field>

                </div>

              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[1][1]">
              <mat-expansion-panel-header>
                <mat-panel-title> Reference Resources</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Reference Resources -->
              <div class="sections">
                <p-table *ngIf="referenceResources" [value]="referenceResources" #table>

                  <ng-template pTemplate="header">
                    <tr style="white-space: nowrap;font-weight: bold">
                      <th *ngFor="let col of referenceResourceCols" [pSortableColumn]="col.field"
                          [ngStyle]="{'width': col.width || 'auto'}">
                        {{ col.header }}
                      </th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-item>
                    <tr [pSelectableRow]="item">
                      <td>
                        <a
                          *ngIf="item.url?.startsWith('http://') || item.url?.startsWith('https://') || item.url?.startsWith('\\\\')"
                          [attr.href]="item.url" target="_blank" class="btn btn-link">{{ item.name }}</a>
                      </td>
                      <td style="font-size: 0.75; word-break: break-all">
                        {{ item.sourceProvider }}
                      </td>
                      <td>
                        {{ item.notes }}
                      </td>
                    </tr>
                  </ng-template>

                </p-table>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[1][2]">
              <mat-expansion-panel-header>
                <mat-panel-title> Recommended Solutions</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Recommended Solutions -->
              <div class="sections">
                <p-table *ngIf="potentialRecommendedSolutions" [value]="potentialRecommendedSolutions" #table>

                  <ng-template pTemplate="header">
                    <tr style="white-space: nowrap;font-weight: bold">
                      <th *ngFor="let col of recommendedSolutionCols" [pSortableColumn]="col.field"
                          [ngStyle]="{'width': col.width || 'auto'}">
                        {{ col.header }}
                      </th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-item>
                    <tr [pSelectableRow]="item">
                      <td>
                        <img [src]="item.logoUrl" style="max-width: 64px; max-height: 64px;"
                             *ngIf="item.listLogoFileName" />
                      </td>
                      <td style="font-size: 0.75; word-break: break-all">
                        {{ item.parent }}
                      </td>
                      <td>
                        <a
                          *ngIf="item.url?.startsWith('http://') || item.url?.startsWith('https://') || item.url?.startsWith('\\\\')"
                          [attr.href]="item.url" target="_blank" class="btn btn-link">
                          {{ item.name }}
                        </a>
                        <ng-container *ngIf="!item.url?.startsWith('http://') && !item.url?.startsWith('https://') && !item.url?.startsWith('\\\\')">{{item.name}}</ng-container>
                      </td>
                      <td>
                        <div [innerHTML]="item.details" style="padding-top: 18px;"></div>
                      </td>
                      <td>
                        <div>{{item.inheritance}}</div>
                      </td>
                      <td>
                        {{ item.price }}
                      </td>
                      <td>
                        {{ item.configDetails }}
                      </td>
                      <td>{{ item.contact }}</td>
                    </tr>
                  </ng-template>

                </p-table>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[1][3]">
              <mat-expansion-panel-header>
                <mat-panel-title> Collaboration</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Collaboration -->
              <div class="sections">
                <div style="display: flex; flex-direction: row; justify-content: start; align-items: center; margin: 15px 0px 15px 0px; justify-content: flex-start; align-items: stretch">


                  <div style="flex:25%">
                    <mat-checkbox class="example-margin" style="margin-top: 14px; display: block;"
                                  [(ngModel)]="originalProjectControlItem.reviewRequired"
                                  (change)="onReviewRequiredChange()"
                                  name="reviewRequired">
                      Request Review
                    </mat-checkbox>
                  </div>

                  <div style="flex:25%; display: flex; flex-direction: column; justify-content: space-between">
                    <mat-checkbox class="example-margin" style="margin-top: 14px; display: block;"
                                  [(ngModel)]="originalProjectControlItem.reviewedByConsultant"
                                  (change)="onReviewedByConsultantChange()" name="reviewedByConsultant"
                                  disabled="{{!canReview}}">
                      Reviewed By Advisor
                    </mat-checkbox>
                  </div>

                  <div class="sublabel" *ngIf="originalProjectControlItem.lastReviewedBy">
                    Reviewed by
                    {{ originalProjectControlItem.lastReviewedBy }} on {{
                      originalProjectControlItem.lastReviewedDate |
                        date :
                        'shortDate'
                    }} {{ originalProjectControlItem.lastReviewedDate | date : 'shortTime' }}
                  </div>
                </div>


                <div class="form-group">
                  <mat-label style="color: rgba(0,0,0,.54);font-size: 15px; font-family: 600;">
                    Advisor Standing
                    Instructions <span class="pi pi-pencil"
                                       (click)="visibility.consultantInstructionsEdit = !visibility.consultantInstructionsEdit"></span>
                  </mat-label>
                  <div class="Summary" *ngIf="visibility.consultantInstructionsEdit === false"
                       [innerHTML]="addToken(visibility.consultantInstructions) | sanitizeHtml"></div>
                  <p-editor matInput *ngIf="originalProjectControlItem.consultantInstructionsEdit" type="text"
                            name="references" [(ngModel)]="originalProjectControlItem.consultantInstructions"
                            #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                    <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                      <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                      <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                      <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                      <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                    </p-header>
                  </p-editor>
                </div>
                <div>
                  <mat-form-field class="textarea-section">
                    <mat-label>Client Standing Instructions</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" rows="5"
                              cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" type="text" name="clientInstructions"
                              [(ngModel)]="originalProjectControlItem.clientInstructions" #clientInstructions="ngModel"
                              [disabled]="!isManagerUser" style="line-height: 2em;">
         </textarea>
                  </mat-form-field>
                </div>

                <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;" >

                  <div style="flex:49%">
                    <div class="form-group">
                      <mat-form-field class="notes-section">
                        <mat-label>Advisor notes</mat-label>
                        <textarea matInput cdkAutosizeMinRows="10" rows="5" cdkAutosizeMaxRows="10" type="text"
                                  name="consultantNotes" [(ngModel)]="consultantNotes" readonly
                                  style="line-height: 2em;">
                 </textarea>
                      </mat-form-field>
                    </div>

                    <div class="add-message-group" *ngIf='!isNotConsultant'>
                      <button mat-raised-button class="add-message-button" (click)="onAddConsultantNote()">
                        Add message
                      </button>
                      <div style="overflow: hidden; padding-right: .5em;">
                        <input type="text" class="write-message-input" placeholder="Write your message here..."
                               [(ngModel)]="draftMessage" name="draftMessage" />
                      </div>

                    </div>
                  </div>

                  <div style="flex:2%"></div>

                  <div style="flex:49%">
                    <div class="form-group">
                      <mat-form-field class="notes-section">
                        <mat-label>Client Notes</mat-label>
                        <textarea matInput cdkAutosizeMinRows="10" cdkAutosizeMaxRows="10" type="text" rows="5"
                                  name="clientNotes" [(ngModel)]="clientNotes" readonly style="line-height: 2em;">
                </textarea>
                      </mat-form-field>
                    </div>

                    <div class="add-message-group" *ngIf='isNotConsultant'>
                      <button mat-raised-button class="add-message-button" (click)="onAddClientNote()">
                        Add message
                      </button>
                      <div style="overflow: hidden; padding-right: .5em;">
                        <input type="text" class="write-message-input" placeholder="Write your message here..."
                               [(ngModel)]="draftMessage" name="draftMessage" />
                      </div>

                    </div>
                  </div>
                </div>

                <div style="width: 100%; display: flex; justify-content: flex-start; gap: 30px;">
                  <div>
                    <mat-form-field class="textarea-section">
                      <mat-label>Related Controls</mat-label>
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="4" type="text" name="relatedControls" cols="60"
                                [(ngModel)]="originalProjectControlItem.relatedControls" #description="ngModel"
                                [disabled]="isReadOnly(originalProjectControlItem) && !isManagerUser">
              </textarea>
                    </mat-form-field>
                  </div>
                  <div style="display: flex;">
                    <mat-form-field [class.hide-input]="originalProjectControlItem.sourceProjectControlItem"
                                    class="textarea-section">
                      <mat-label>Source Control</mat-label>
                      <mat-chip-grid #sourceChipList>
                        <mat-chip-row class="related" *ngIf="originalProjectControlItem.sourceProjectControlItem"
                                      pTooltip="{{originalProjectControlItem.sourceProjectControlItem.controlItem.description}}"
                                      tooltipPosition="top">
                          <a
                            [routerLink]="['projects/project/', originalProjectControlItem.sourceProjectControlItem.projectId, originalProjectControlItem.sourceProjectControlItem.projectControlItemId]">
                            {{ originalProjectControlItem.sourceProjectControlItem.controlItem.category }}
                            -
                            {{ originalProjectControlItem.sourceProjectControlItem.controlItem.complianceAreaControlId }}
                          </a>
                        </mat-chip-row>
                      </mat-chip-grid>
                      <input [matChipInputFor]="sourceChipList" [matChipInputAddOnBlur]="false" matInput readonly
                             (click)="addSource()">

                    </mat-form-field>
                    <button matSuffix *ngIf="!originalProjectControlItem.sourceProjectControlItem" mat-icon-button
                            (click)="addSource()" class="add-btn">
                      <i class="pi pi-plus" style="margin-left:0px"></i>
                    </button>
                  </div>
                </div>

                <div style="width: 100%; display: flex; justify-content: flex-start; gap: 30px;">
                  <div style="display: flex;">
                    <mat-form-field [class.hide-input]="originalProjectControlItem.relatedProjectControlItems.length"
                                    class="textarea-section">
                      <mat-label>Related Control Items</mat-label>
                      <mat-chip-grid #relatedChipList>
                        <mat-chip-row class="related"
                                      *ngFor="let r of originalProjectControlItem.relatedProjectControlItems"
                                      pTooltip="{{r.controlItem.description}}" tooltipPosition="top">
                          <a [routerLink]="['projects/project/', r.projectId, r.projectControlItemId]">
                            {{ r.controlItem.category }}
                            - {{ r.controlItem.complianceAreaControlId }}
                            <mat-icon (click)="removeProjectControlItem(r, $event)" matChipRemove>cancel</mat-icon>
                          </a>
                        </mat-chip-row>
                      </mat-chip-grid>
                      <input [matChipInputFor]="relatedChipList" [matChipInputAddOnBlur]="false" matInput readonly />

                    </mat-form-field>
                    <button matSuffix mat-icon-button (click)="addRelated()" class="add-btn">
                      <i class="pi pi-plus" style="margin-left:0px"></i>
                    </button>
                  </div>
                  <div style="display: flex;">
                    <mat-form-field class="textarea-section"
                                    [class.hide-input]="originalProjectControlItem.dependenciesProjectControlItems.length">
                      <mat-label>Dependencies</mat-label>
                      <mat-chip-grid #depencenciesChipList>
                        <mat-chip-row class="related"
                                      *ngFor="let r of originalProjectControlItem.dependenciesProjectControlItems"
                                      pTooltip="{{r.controlItem.description}}" tooltipPosition="top">
                          <a [routerLink]="['projects/project/', r.projectId, r.projectControlItemId]">
                            {{ r.controlItem.category }}
                            - {{ r.controlItem.complianceAreaControlId }}
                            <mat-icon (click)="removeDependencyProjectControlItem(r, $event)"
                                      matChipRemove>cancel
                            </mat-icon>
                          </a>
                        </mat-chip-row>
                      </mat-chip-grid>
                      <input [matChipInputFor]="depencenciesChipList" [matChipInputAddOnBlur]="false" matInput
                             readonly />

                    </mat-form-field>
                    <button matSuffix mat-icon-button (click)="addDependency()" class="add-btn">
                      <i class="pi pi-plus" style="margin-left:0px"></i>
                    </button>
                  </div>
                </div>

              </div>
            </mat-expansion-panel>
          </mat-accordion>

        </div>
      </mat-tab>
      <mat-tab label="Implementation">
        <div class="section">
          <mat-accordion [multi]="true">
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[2][0]">
              <mat-expansion-panel-header>
                <mat-panel-title> Implementation Control Statement</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Implementation Control Statement -->

              <div class="sections" style="display: grid;">
                <div>
                  <mat-label
                    style="color: rgba(0,0,0,.54);font-size: 15px; font-weight: 600; margin-bottom: 14px; position:absolute; left:273px; top:15px ;cursor:pointer">
                    <span class="pi pi-list" *ngIf="isImplementationSontrolStatementsEnabled"
                          (click)="selectImplementationControlStatement()"></span>
                    <span class="pi pi-link"
                          *ngIf="isImplementationSontrolStatementsEnabled && !originalProjectControlItem.implementationControlStatementId"
                          (click)="selectImplementationControlStatementForLink()"></span>
                    <span class="pi pi-link" style="color: var(--main-ui-color, orange);"
                          *ngIf="isImplementationSontrolStatementsEnabled && originalProjectControlItem.implementationControlStatementId"
                          (click)="originalProjectControlItem.implementationControlStatementId = null; originalProjectControlItem.solutionDescription = linkedImplementationControlStatement; linkedImplementationControlStatement = ''"></span>

                    <span *ngIf="originalProjectControlItem.noOfIcsSections != '3'" style="margin-bottom: 9px;"
                          class="pi pi-plus" (click)="addIcsSection()"></span>
                    <span class="pi pi-book"
                          (click)="visibility.showDescriptionForIcs = !visibility.showDescriptionForIcs"></span>
                    <span class="pi pi-briefcase" *ngIf="tenantPermissions.isElixirEnabled"
                          (click)="generateICS()"></span>
                    <span class="cursor-pointer" style="margin-left: 5px;" *ngIf="tenantPermissions.isElixirEnabled"
                          (click)="isRecommendationsVisible = !isRecommendationsVisible">3P</span>
                  </mat-label>
                  <span>
                    <div *ngIf="visibility.showDescriptionForIcs" style="white-space: pre;">
                      {{ originalProjectControlItem.controlItem.description }}
                    </div>
                    <div class="section_div">
                      <div style="display: flex;gap: 15px;">
                        <p style="margin-bottom: 6px;margin-top: 3px;">Core ICS</p>
                        <p *ngIf="getSourceForICS1()"
                           style="margin-bottom: 6px;margin-top: 3px;margin-left: 5px;color: rgba(0, 0, 0, 0.54)">
                          Mapped From Source: {{ getSourceForICS1()?.fromComplianceAreaName }} - {{
                            getSourceForICS1()?.fromControlItemName
                          }}
                        </p>
                      </div>
                      <span class="pi pi-pencil" style="margin-top:4px"
                            *ngIf="isImplementationSontrolStatementsEnabled && !originalProjectControlItem.implementationControlStatementId"
                            (click)="visibility.solutionDescriptionEdit = !visibility.solutionDescriptionEdit"></span>
                    </div>
                    <div class="Summary"
                         *ngIf="!originalProjectControlItem.implementationControlStatementId && !visibility.solutionDescriptionEdit"
                         [innerHTML]="addToken(originalProjectControlItem.solutionDescription) | sanitizeHtml"></div>
                    <div class="Summary" *ngIf="originalProjectControlItem.implementationControlStatementId"
                         [innerHTML]="addToken(linkedImplementationControlStatement) | sanitizeHtml"></div>

                    <p-editor matInput
                              *ngIf="!originalProjectControlItem.implementationControlStatementId && visibility.solutionDescriptionEdit"
                              height="200" type="text" name="references"
                              [(ngModel)]="originalProjectControlItem.solutionDescription" #description="ngModel"
                              (ngModelChange)="updateScore()"
                              [disabled]="isReadOnly(originalProjectControlItem)">
                      <p-header>
                        <span class="ql-formats">
                          <select class="ql-size">
                            <option value="huge">Heading</option>
                            <option value="large">Subheading</option>
                            <option selected></option>
                            <option value="small">Small</option>
                          </select>
                          <select class="ql-font">
                            <option selected="">Sans Serif</option>
                            <option value="serif">Serif</option>
                            <option value="monospace">Monospace</option>
                          </select>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-bold" aria-label="Bold"></button>
                          <button class="ql-italic" aria-label="Italic"></button>
                          <button class="ql-underline" aria-label="Underline"></button>
                          <button class="ql-strike" aria-label="Strike"></button>
                        </span>
                        <span class="ql-formats">
                          <select class="ql-color">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                          <select class="ql-background">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-list" value="ordered"></button>
                          <button class="ql-list" value="bullet"></button>
                          <select title="Text Alignment" class="ql-align">
                            <option selected>Left</option>
                            <option value="center" label="Center"></option>
                            <option value="right" label="Right"></option>
                            <option value="justify" label="Justify"></option>
                          </select>
                          <button class="ql-indent" value="-1"></button>
                          <button class="ql-indent" value="+1"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Link" class="ql-link"></button>
                          <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                  #el (click)="selectDocument(el)">
                            D
                          </button>
                          <button aria-label="Image" class="ql-image"></button>
                          <button aria-label="Code block" class="ql-code-block"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Clean" class="ql-clean"></button>
                        </span>
                      </p-header>
                    </p-editor>
                    <div *ngIf="originalProjectControlItem.solutionDescriptionLastUpdated">
                      <span style="display: flex;">
                        <p>Last Updated: </p><small style="margin-top:1px">
                          &nbsp; {{
                          originalProjectControlItem.solutionDescriptionLastUpdated | date:'MM/dd/yyyy'
                        }}
                        </small>
                      </span>
                    </div>
                  </span>
                  <span
                    *ngIf="originalProjectControlItem.noOfIcsSections == '2' || originalProjectControlItem.noOfIcsSections == '3'">
                    <div class="section_div">
                      <div style="display: flex;gap: 15px;">
                        <p style="margin-bottom: 6px;margin-top: 3px;">ICS-2</p>

                        <p *ngIf="getSourceForICS2()"
                           style="margin-bottom: 6px;margin-top: 3px;margin-left: 5px;color: rgba(0, 0, 0, 0.54)">
                          Mapped From Source: {{ getSourceForICS2()?.fromComplianceAreaName }} - {{
                            getSourceForICS2()?.fromControlItemName
                          }}
                        </p>
                      </div>
                      <span>
                        <span class="pi pi-pencil" style="margin-top:4px"
                              *ngIf="isImplementationSontrolStatementsEnabled && !originalProjectControlItem.newSection1Id"
                              (click)="visibility.newSection1Edit = !visibility.newSection1Edit"></span>
                        <span class="pi pi-trash" style="margin-top:4px"
                              *ngIf="isImplementationSontrolStatementsEnabled && !originalProjectControlItem.newSection3Id"
                              mwlConfirmationPopover
                              [title]="'Remove ICS-3'"
                              [popoverMessage]="'Are you sure Y/N'"
                              [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                              (confirm)="removeIcsSection(2)"></span>
                      </span>
                    </div>
                    <div class="Summary"
                         *ngIf="!originalProjectControlItem.newSection1Id && !visibility.newSection1Edit"
                         [innerHTML]="addToken(originalProjectControlItem.solutionDescription2) | sanitizeHtml"></div>
                    <p-editor matInput *ngIf="!originalProjectControlItem.newSection1Id && visibility.newSection1Edit"
                              height="200" type="text" name="newSection1"
                              [(ngModel)]="originalProjectControlItem.solutionDescription2"
                              #newSection1Description="ngModel"
                              [disabled]="isReadOnly(originalProjectControlItem)">
                      <p-header>
                        <span class="ql-formats">
                          <select class="ql-size">
                            <option value="huge">Heading</option>
                            <option value="large">Subheading</option>
                            <option selected></option>
                            <option value="small">Small</option>
                          </select>
                          <select class="ql-font">
                            <option selected="">Sans Serif</option>
                            <option value="serif">Serif</option>
                            <option value="monospace">Monospace</option>
                          </select>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-bold" aria-label="Bold"></button>
                          <button class="ql-italic" aria-label="Italic"></button>
                          <button class="ql-underline" aria-label="Underline"></button>
                          <button class="ql-strike" aria-label="Strike"></button>
                        </span>
                        <span class="ql-formats">
                          <select class="ql-color">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                          <select class="ql-background">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-list" value="ordered"></button>
                          <button class="ql-list" value="bullet"></button>
                          <select title="Text Alignment" class="ql-align">
                            <option selected>Left</option>
                            <option value="center" label="Center"></option>
                            <option value="right" label="Right"></option>
                            <option value="justify" label="Justify"></option>
                          </select>
                          <button class="ql-indent" value="-1"></button>
                          <button class="ql-indent" value="+1"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Link" class="ql-link"></button>
                          <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                  #el (click)="selectDocument(el)">
                            D
                          </button>
                          <button aria-label="Image" class="ql-image"></button>
                          <button aria-label="Code block" class="ql-code-block"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Clean" class="ql-clean"></button>
                        </span>
                      </p-header>
                    </p-editor>
                    <div *ngIf="originalProjectControlItem.solutionDescription2LastUpdated">
                      <span style="display: flex;">
                        <p>Last Updated: </p><small style="margin-top:1px">
                          &nbsp; {{
                          originalProjectControlItem.solutionDescription2LastUpdated | date:'MM/dd/yyyy'
                        }}
                        </small>
                      </span>
                    </div>
                  </span>
                  <span *ngIf="originalProjectControlItem.noOfIcsSections == '3'">
                    <div class="section_div">
                      <div style="display: flex;gap: 15px;">
                        <p style="margin-bottom: 6px;margin-top: 3px;">ICS-3</p>

                        <p *ngIf="getSourceForICS3()"
                           style="margin-bottom: 6px;margin-top: 3px;margin-left: 5px;color: rgba(0, 0, 0, 0.54)">
                          Mapped From Source: {{ getSourceForICS3()?.fromComplianceAreaName }} - {{
                            getSourceForICS3()?.fromControlItemName
                          }}
                        </p>
                      </div>
                      <span>
                        <span class="pi pi-pencil" style="margin-top:4px"
                              *ngIf="isImplementationSontrolStatementsEnabled && !originalProjectControlItem.newSection2Id"
                              (click)="visibility.newSection2Edit = !visibility.newSection2Edit"></span>
                        <span class="pi pi-trash" style="margin-top:4px"
                              *ngIf="isImplementationSontrolStatementsEnabled && !originalProjectControlItem.newSection3Id"
                              mwlConfirmationPopover
                              [title]="'Remove ICS-3'"
                              [popoverMessage]="'Are you sure Y/N'"
                              [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                              (confirm)="removeIcsSection(3)"></span>
                      </span>
                    </div>
                    <div class="Summary"
                         *ngIf="!originalProjectControlItem.newSection2Id && !visibility.newSection2Edit"
                         [innerHTML]="addToken(originalProjectControlItem.solutionDescription3) | sanitizeHtml"></div>
                    <p-editor matInput *ngIf="!originalProjectControlItem.newSection2Id && visibility.newSection2Edit"
                              height="200" type="text" name="newSection1"
                              [(ngModel)]="originalProjectControlItem.solutionDescription3"
                              #newSection1Description="ngModel"
                              [disabled]="isReadOnly(originalProjectControlItem)">
                      <p-header>
                        <span class="ql-formats">
                          <select class="ql-size">
                            <option value="huge">Heading</option>
                            <option value="large">Subheading</option>
                            <option selected></option>
                            <option value="small">Small</option>
                          </select>
                          <select class="ql-font">
                            <option selected="">Sans Serif</option>
                            <option value="serif">Serif</option>
                            <option value="monospace">Monospace</option>
                          </select>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-bold" aria-label="Bold"></button>
                          <button class="ql-italic" aria-label="Italic"></button>
                          <button class="ql-underline" aria-label="Underline"></button>
                          <button class="ql-strike" aria-label="Strike"></button>
                        </span>
                        <span class="ql-formats">
                          <select class="ql-color">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                          <select class="ql-background">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-list" value="ordered"></button>
                          <button class="ql-list" value="bullet"></button>
                          <select title="Text Alignment" class="ql-align">
                            <option selected>Left</option>
                            <option value="center" label="Center"></option>
                            <option value="right" label="Right"></option>
                            <option value="justify" label="Justify"></option>
                          </select>
                          <button class="ql-indent" value="-1"></button>
                          <button class="ql-indent" value="+1"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Link" class="ql-link"></button>
                          <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                  #el (click)="selectDocument(el)">
                            D
                          </button>
                          <button aria-label="Image" class="ql-image"></button>
                          <button aria-label="Code block" class="ql-code-block"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Clean" class="ql-clean"></button>
                        </span>
                      </p-header>
                    </p-editor>
                    <div *ngIf="originalProjectControlItem.solutionDescription3LastUpdated">
                      <span style="display: flex;">
                        <p>Last Updated: </p><small style="margin-top:1px">
                          &nbsp; {{
                          originalProjectControlItem.solutionDescription3LastUpdated | date:'MM/dd/yyyy'
                        }}
                        </small>
                      </span>
                    </div>
                  </span>
                  @if (isRecommendationsVisible) {
                    @for (assessmentObjective of assessmentObjectives; track assessmentObjective; let i = $index) {
                      <div>
                        <h5 class="font-bold">{{assessmentObjective}}</h5>
                      </div>
                      <div>
                        <mat-label class="font-bold">Findings/Notes</mat-label>
                        <div [innerHTML]="addToken(originalProjectControlItem.findingsNotesList[i])"></div>
                      </div>
                      <div>
                        <mat-label class="font-bold">Recommendations</mat-label>
                        <div [innerHTML]="addToken(originalProjectControlItem.recommendationsList[i])"></div>
                      </div>
                    }
                  }
                </div>

                <div style="display: flex; gap: 20px;">
                  <div style="margin-top: 10px;">
                    <mat-checkbox [(ngModel)]="originalProjectControlItem.implementationControlStatusNotNeeded">
                      Implementation
                      Control
                      Statement is not required
                    </mat-checkbox>
                  </div>
                  <mat-form-field class="input-section" style="width:300px;">
                    <mat-label>Rationale/Discussion</mat-label>
                    <input matInput name="rationale" [(ngModel)]="originalProjectControlItem.rationale"
                           [disabled]="isReadOnly(originalProjectControlItem) && !isManager">
                    <div matSuffix class="tooltip-trigger"
                         pTooltip='Explanation required when the implementation status is "Alternative Implementation" or "Not Applicable"'>
                    </div>
                  </mat-form-field>
                  <div style="margin: 15px 0 15px 0" *ngIf="originalProjectControlItem.lastCompletedBy">
                    <div>
                      <div class="sublabel">
                        Item due on {{ formatDate(originalProjectControlItem.lastCompletedPeriod) }}
                        Completed by
                        {{ originalProjectControlItem.lastCompletedBy }} on {{
                          originalProjectControlItem.lastCompletedDate
                            | date :
                            'shortDate'
                        }} {{ originalProjectControlItem.lastCompletedDate | date : 'shortTime' }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[2][1]">
              <mat-expansion-panel-header>
                <mat-panel-title> Controls Testing</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Controls Testing -->
              <div>
                <div style="display: flex; gap: 20px;">
                  <mat-form-field class="input-section" *ngIf="selectedCompletionPeriod">
                    <mat-label>Note</mat-label>
                    <input matInput [(ngModel)]="selectedCompletionPeriod.note" />
                  </mat-form-field>
                  <mat-form-field class="input-section">
                    <mat-label>Test Status</mat-label>
                    <mat-select [(ngModel)]="originalProjectControlItem.testStatus" name="testStatus"
                                disabled="{{isReadOnly(originalProjectControlItem) && !isManager}}">
                      <mat-option value="0">Not Tested</mat-option>
                      <mat-option value="1">In Progress</mat-option>
                      <mat-option value="2">Completed</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="input-section">
                    <mat-label>Test Performer</mat-label>
                    <mat-select [(ngModel)]="originalProjectControlItem.testPerformer" name="testPerformer"
                                disabled="{{isReadOnly(originalProjectControlItem) && !isManager}}">
                      <mat-option value="0">Internal Resource</mat-option>
                      <mat-option value="1">Independent Auditor</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="input-section">
                    <mat-label>Date</mat-label>
                    <input matInput [matDatepicker]="testDatePicker" name="testDate"
                           [(ngModel)]="originalProjectControlItem.testDate"
                           disabled="{{isReadOnly(originalProjectControlItem) && !isManagerUser}}" required>

                    <mat-datepicker-toggle matSuffix [for]="testDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #testDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[2][2]">
              <mat-expansion-panel-header>
                <mat-panel-title> Inherited Controls</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Inherited Controls -->
              <div class="sections" style="display: grid;" [formGroup]="sharedResponsibilityForm">
                <div style="display: flex; gap: 20px;">
                  <div>
                    <mat-form-field class="input-section" style="width:200px">
                      <mat-label>Vendor</mat-label>
                      <mat-select (selectionChange)="vendorChanged()" formControlName="vendorId">
                        <mat-option [value]="vendor.itemId" *ngFor="let vendor of vendors">{{ vendor.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <i class="pi pi-plus" (click)="addVendor()"></i>
                  </div>
                  <mat-form-field class="input-section" style="width:200px">
                    <mat-label>Topic</mat-label>
                    <mat-select formControlName="securityTopic" (selectionChange)="topicChanged()">
                      <mat-option value="''"></mat-option>
                      <mat-option [value]="topic"
                                  *ngFor="let topic of securityTopics">{{ topic || '[empty]' }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:200px">
                    <mat-label>Solution Name</mat-label>
                    <mat-select formControlName="serviceId" (selectionChange)="serviceChanged()">
                      <mat-option value="0"></mat-option>
                      <mat-option [value]="service.itemId"
                                  *ngFor="let service of filteredServices">{{ service.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:200px">
                    <mat-label>Responsibility</mat-label>
                    <input matInput formControlName="responsibility">
                  </mat-form-field>
                  <div>
                    <mat-form-field class="input-section" style="margin-top:5px;width:200px">
                      <mat-label>Point of Contact</mat-label>
                      <input matInput formControlName="contacts" />
                    </mat-form-field>
                  </div>
                  <div style="width: auto;" class="save-button">
                    <button style="width:122px; background-color: var(--main-ui-color, orange);white-space: nowrap;"
                            mat-raised-button
                            (click)="addServiceToList()">
                      {{
                        isResponsibilityEdit ? 'Save' : 'Add Solution'
                      }}
                    </button>
                  </div>
                </div>


                <p-table [value]="originalProjectControlItem.sharedResponsibilities">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Vendor</th>
                      <th>Solution Name - Topic</th>
                      <th>Responsibility</th>
                      <th>Point of Contact</th>
                      <th style="width: 10em;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item let-expanded="expanded">
                    <tr>
                      <td (click)="item.expanded = !item.expanded">
                        <span class="pi pi-chevron-right" style="margin-left: 0;"
                              *ngIf="(item.service?.details || item.service?.details2) && !item.expanded"></span>
                        <span class="pi pi-chevron-down" style="margin-left: 0;"
                              *ngIf="(item.service?.details || item.service?.details2) && item.expanded"></span>
                        {{ item.service?.vendor }}
                      </td>
                      <td
                        (click)="item.expanded = !item.expanded">{{ item.service?.name }}{{ item.service?.securityTopic ? (' - ' + item.service?.securityTopic) : '' }}
                      </td>
                      <td (click)="item.expanded = !item.expanded">
                        {{ item.responsibility }}
                      </td>
                      <td (click)="item.expanded = !item.expanded">{{ item.contacts }}</td>
                      <td>
                        <i class="pi pi-pencil" style="cursor: pointer;" (click)="editSharedResponsibility(item)"></i>
                        <i class="pi pi-trash" style="cursor: pointer;" (click)="deleteSharedResponsibility(item)"></i>
                      </td>
                    </tr>
                    <tr *ngIf="item.expanded">
                      <td colspan="5">
                        <table style="width: 100%;">
                          <thead>
                          <th style="font-weight: bold;">Sub-Topic</th>
                          <th style="font-weight: bold;">Supporting Features</th>
                          <th style="font-weight: bold;">Fulfillment Method</th>
                          <th style="font-weight: bold;">Responsibility</th>
                          <th style="font-weight: bold;width: 20%;">URL</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ item.service?.securityTopic }}</td>
                              <td>{{ item.service?.supportingFeatures }}</td>
                              <td>{{ item.service?.fulfillmentMethod }}</td>
                              <td>{{ item.service?.inheritance }}</td>
                              <td>{{ item.service?.url }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div *ngIf="item.service?.guidance">
                          <div style="font-size: 14px; font-weight: bold;">Guidance</div>
                          <div class="ql-editor" [innerHTML]="addToken(item.service?.guidance) | sanitizeHtml"></div>
                          </div>
                        <div *ngIf="item.service?.details">
                          <div style="font-size: 14px; font-weight: bold;">Customer Responsibilities</div>
                          <div class="ql-editor"
                               [innerHTML]="addToken(item.service?.customerResponsibilities) | sanitizeHtml"></div>
                          </div>
                        <div *ngIf="item.service?.details2">
                          <div style="font-size: 14px; font-weight: bold;">Implementation Details</div>
                          <div class="ql-editor" [innerHTML]="addToken(item.service?.details2) | sanitizeHtml"></div>
                          </div>

                        <mat-expansion-panel *ngIf="item.service?.configInfo"
                                             [expanded]="nestedPanelOpenState()"
                                             (opened)="nestedPanelOpenState.set(true)"
                                             (closed)="nestedPanelOpenState.set(false)"
                                             style="box-shadow: none !important; border: none !important;">

                          <mat-expansion-panel-header style="background: none !important; padding: 0 !important; margin: 0 !important;">
                            <div style="display: flex; align-items: center; gap: 3.5px; justify-content: flex-start; width: 100%; font-weight: bold;">
                              <span [ngClass]="{'rotate': nestedPanelOpenState()}"
                                    class="pi pi-chevron-right"
                                    style="transition: transform 0.3s ease;">
                              </span>
                              <span>Config Info</span>
                            </div>
                          </mat-expansion-panel-header>

                          <div class="ql-editor"
                               [innerHTML]="addToken(item.service?.configInfo) | sanitizeHtml"
                               style="margin: 0; padding: 0; text-align: left;">
                          </div>
                        </mat-expansion-panel>

                        <div *ngIf="tenantPermissions.isElixirEnabled"
                             style="display: flex; justify-content: flex-start; margin-top: 16px; padding-bottom: 16px;">
                          <button mat-raised-button
                                  color="primary"
                                  style="background: orange; color: white;"
                                  (click)="generateGuidanceForService(item.service)">
                            Elixir
                          </button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>

              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[2][3]">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Gaps (Plan of Action &amp; Milestones)
                </mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Gaps (Plan of Action &amp; Milestones) -->
              <div class="sections" [formGroup]="actionPlanForm">
                <div formArrayName="actionPlans">

                  <p-table [value]="actionPlanForm.controls.actionPlans.controls" dataKey="value.number"
                           #actionPlanTable [expandedRowKeys]="expandedActionPlans">

                    <ng-template pTemplate="header">
                      <tr style="white-space: nowrap;font-weight: bold">
                        <th style="width:5em"></th>
                        <th *ngFor="let col of actionPlanCols" [pSortableColumn]="col.field">
                          {{ col.header }}
                        </th>
                        <th style="width:10em"></th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                                 let-columns="columns">
                      <tr [pRowToggler]="item" [attr.id]="'actionPlanBlock' + rowIndex">
                        <td style="width:5em;">
                          <span>
                            <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                          </span>
                        </td>
                        <td>
                          {{ item.value.name }}
                          <i
                            *ngIf="item.value.actionPlanTemplateId && actionPlanTemplatesMap[item.value.actionPlanTemplateId] && !actionPlanTemplatesMap[item.value.actionPlanTemplateId].projectId">
                            <img src="../../../assets/icon/globe-americas-regular.svg"
                                 style="height: 14px; margin-left: 4px" />
                          </i>
                          <i
                            *ngIf="item.value.actionPlanTemplateId && actionPlanTemplatesMap[item.value.actionPlanTemplateId] && actionPlanTemplatesMap[item.value.actionPlanTemplateId].projectId">
                            <img src="../../../assets/icon/island-tropical-solid.svg"
                                 style="height: 14px; margin-left: 4px" />
                          </i>
                        </td>
                        <td>
                          {{ item.value.weaknessDescription }}
                        </td>
                        <td>{{ actionItemStatuses[item.value.currentStatus] }}</td>
                        <td>{{ item.value.scheduledCompletionDate | date: 'shortDate' }}</td>
                        <td>
                          <ul style="padding-left: 2em;" *ngIf="item.value.assessmentNotes">
                            <li *ngFor="let note of item.value.assessmentNotes">
                              A{{ note.assessmentNoteId }} -
                              {{ note.name }}
                            </li>
                          </ul>
                        </td>
                        <td>
                          <span (click)="removeActionPlan(rowIndex)" class="pi pi-trash"></span>
                          <span *ngIf="!item.value.actionPlanTemplateId" (click)="createActionPlanTemplate(item)"
                                style="float: none;margin-top:20px;margin-left: 10px;cursor: pointer;">
                            <img src="../../../assets/icon/share-alt-regular.svg"
                                 style="height: 10px;margin-bottom: 2px;" />
                          </span>
                        </td>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex">
                      <tr style="font-size: 13px;">
                        <td [formGroupName]="rowIndex" colspan="7">
                          <div style="display: flex; gap: 20px; margin-top: 10px;">
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Topic</mat-label>
                              <input matInput type="text" name="name" formControlName="topic"
                                     [readonly]="isReadOnly(originalProjectControlItem) && !isManagerUser || actionPlanTemplatesMap[item.value.actionPlanTemplateId]?.isProtected"
                                     required>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Name</mat-label>
                              <input matInput type="text" name="name" formControlName="name"
                                     [readonly]="isReadOnly(originalProjectControlItem) && !isManagerUser || actionPlanTemplatesMap[item.value.actionPlanTemplateId]?.isProtected"
                                     required>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Risk Level</mat-label>
                              <mat-select formControlName="riskLevel"
                                          [disabled]="actionPlanTemplatesMap[item.value.actionPlanTemplateId]?.isProtected">
                                <mat-option [value]="'High'">High</mat-option>
                                <mat-option [value]="'Medium'">Medium</mat-option>
                                <mat-option [value]="'Low'">Low</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Source</mat-label>
                              <mat-select formControlName="source">
                                <mat-option [value]="'Manually Created'">Manually Created</mat-option>
                                <mat-option [value]="'Validation Finding'">Validation Finding</mat-option>
                                <mat-option [value]="'POAM API'">POAM API</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>System</mat-label>
                              <input matInput type="text" name="system" formControlName="system"
                                     required>
                            </mat-form-field>
                          </div>
                          <div style="display: flex; gap: 20px;">
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Description</mat-label>
                              <input matInput type="text" name="weaknessDescription"
                                     formControlName="weaknessDescription"
                                     [readonly]="isReadOnly(originalProjectControlItem) && !isManagerUser || actionPlanTemplatesMap[item.value.actionPlanTemplateId]?.isProtected"
                                     required>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Affected Systems</mat-label>
                              <input matInput type="text" name="affectedSystems" formControlName="affectedSystems"
                                     [readonly]="isReadOnly(originalProjectControlItem) && !isManagerUser || actionPlanTemplatesMap[item.value.actionPlanTemplateId]?.isProtected"
                                     required>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Current Status</mat-label>
                              <mat-select formControlName="currentStatus"
                                          [readonly]="isReadOnly(originalProjectControlItem) && !isManagerUser"
                                          required>
                                <mat-option [value]="0">Not Started</mat-option>
                                <mat-option [value]="1">In-Progress</mat-option>
                                <mat-option [value]="2">Resolved</mat-option>
                                <mat-option [value]="3">Awaiting Review</mat-option>
                                <mat-option [value]="4">Reviewed - Not POAM</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>


                          <div style="display: flex; gap: 20px;width:100%">
                            <mat-form-field class="input-section" style="width:25%">
                              <mat-label>Date of Identification</mat-label>
                              <input matInput [matDatepicker]="identificationDatePicker" name="identificationDate"
                                     formControlName="identificationDate"
                                     disabled="{{isReadOnly(originalProjectControlItem) && !isManagerUser}}" required>
                              <mat-datepicker-toggle matSuffix [for]="identificationDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #identificationDatePicker></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:25%">
                              <mat-label>How Identified</mat-label>
                              <input matInput type="text" name="howIdentified" formControlName="howIdentified"
                                     [readonly]="isReadOnly(originalProjectControlItem) && !isManagerUser || actionPlanTemplatesMap[item.value.actionPlanTemplateId]?.isProtected"
                                     required>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:25%">
                              <mat-label>Related Assessments</mat-label>
                              <mat-select formControlName="assessmentNotes"
                                          (selectionChange)="setRelatedAssesssmentNotes(item, $event)" multiple="true">
                                <mat-select-trigger>

                                  <div *ngFor="let note of item.controls.assessmentNotes.value">
                                    A{{ note.assessmentNoteId }} -
                                    {{ note.name }}
                                  </div>
                                </mat-select-trigger>
                                <mat-option *ngFor="let item of originalProjectControlItem.assessmentNotes"
                                            [value]="item">A{{ item.assessmentNoteId }} - {{ item.name }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:25%">
                              <mat-label>Requirements or Guidance</mat-label>
                              <mat-select formControlName="requirementOrGuidance"
                                          [disabled]="actionPlanTemplatesMap[item.value.actionPlanTemplateId]?.isProtected">
                                <mat-option [value]="'Requirement'">Requirement</mat-option>
                                <mat-option [value]="'Guidance'">Guidance</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div style="display: flex; gap: 20px; ">
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>LoE</mat-label>
                              <mat-select formControlName="loe"
                                          [disabled]="actionPlanTemplatesMap[item.value.actionPlanTemplateId]?.isProtected" required>
                                <mat-option [value]="2">High</mat-option>
                                <mat-option [value]="1">Medium</mat-option>
                                <mat-option [value]="0">Low</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Responsible Party</mat-label>
                              <input matInput name="responsibleParty" formControlName="responsibleParty"
                                     [disabled]="isReadOnly(originalProjectControlItem) && !isManagerUser" required>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Remediation Plans, Actions and Milestones</mat-label>
                              <input matInput type="text" name="remediationPlansActionsMilestones"
                                     formControlName="remediationPlansActionsMilestones"
                                     [disabled]="isReadOnly(originalProjectControlItem) && !isManagerUser" required>
                            </mat-form-field>

                          </div>

                          <div style="display: flex; gap: 20px;">
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Target Completion Date</mat-label>
                              <input matInput [matDatepicker]="scheduledCompletionDatePicker"
                                     name="scheduledCompletionDate" formControlName="scheduledCompletionDate"
                                     disabled="{{isReadOnly(originalProjectControlItem) && !isManagerUser}}" required>

                              <mat-datepicker-toggle matSuffix
                                                     [for]="scheduledCompletionDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #scheduledCompletionDatePicker></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>Actual Completion Date</mat-label>
                              <input matInput [matDatepicker]="actualCompletionDatePicker" name="actualCompletionDate"
                                     formControlName="actualCompletionDate"
                                     disabled="{{isReadOnly(originalProjectControlItem) && !isManagerUser}}">

                              <mat-datepicker-toggle matSuffix
                                                     [for]="actualCompletionDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #actualCompletionDatePicker></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:100%">
                              <mat-label>
                                Changes to Remediation Plans, Actions, and Milestones (if
                                applicable)
                              </mat-label>
                              <input matInput type="text" name="changesToRemediationPlansActionsMilestones"
                                     formControlName="changesToRemediationPlansActionsMilestones"
                                     [disabled]="isReadOnly(originalProjectControlItem) && !isManagerUser">
                            </mat-form-field>
                          </div>

                          <div style="display: flex; gap: 20px;">
                            <mat-form-field class="textarea-section" style="width: 100%;">
                              <mat-label>Comments</mat-label>
                              <textarea matInput cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" type="text"
                                        name="comments" formControlName="comments"
                                        disabled="{{isReadOnly(originalProjectControlItem) && !isManagerUser}}">
                        </textarea>
                            </mat-form-field>

                          </div>

                          <div style="display: grid; gap: 20px;">
                            <mat-slide-toggle class="example-margin" name="typeBool" formControlName="typeBool">
                              Visible in POA&M
                            </mat-slide-toggle>
                            @if (!item.value.actionPlanId) {
                              <mat-slide-toggle class="example-margin" name="typeBool" formControlName="createIncidentResponse">
                                Create Incident Response
                              </mat-slide-toggle>
                            }
                          </div>

                          <p style="font-size: 15px;font-weight:600 ;color:#cccccc; ">Attachments</p>
                          <p-table *ngIf="item.value.attachments && users" [value]="item.value.attachments" #table>

                            <ng-template pTemplate="header">
                              <tr style="white-space: nowrap;font-weight: bold">
                                <th *ngFor="let col of actionPlanAttachmentCols" [pSortableColumn]="col.field"
                                    [ngStyle]="{'width': col.width || 'auto'}">
                                  {{ col.header }}
                                </th>
                                <th style="width:10em"></th>
                              </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-file>
                              <tr [pSelectableRow]="file">
                                <td>
                                  {{ file.date | date:'shortDate' }}
                                </td>
                                <td>
                                  <span
                                    *ngIf="!file.name?.startsWith('http://') && !file.name?.startsWith('https://') && !file.name?.startsWith('\\\\')"
                                    (click)="DownloadAttachment(file.name)" class="btn btn-link">{{ file.name }}</span>
                                  <a
                                    *ngIf="file.name?.startsWith('http://') || file.name?.startsWith('https://') || file.name?.startsWith('\\\\')"
                                    target="_blank" [attr.href]="file.name" class="btn btn-link">{{ file.name }}</a>
                                </td>
                                <td>
                                  <span *ngIf="!file.editMode">{{ file.notes }}</span>
                                  <span *ngIf="file.editMode">
                                    <mat-form-field style="width: 100%">
                                      <input matInput (change)="file.notes=$event.target['value']" />
                                    </mat-form-field>
                                  </span>
                                </td>
                                <td>
                                  <button *ngIf="!file.editMode" type="button" pButton class="risksponge-button"
                                          (click)="file.editMode = true; file.oldNotes = file.notes"
                                          icon="pi pi-pencil">
                                  </button>
                                  <button *ngIf="file.editMode" type="button" pButton class="risksponge-button"
                                          (click)="file.editMode = false; saveActionPlanAttachment(file)"
                                          icon="pi pi-check">
                                  </button>
                                  <button *ngIf="file.editMode" type="button" pButton class="risksponge-button"
                                          (click)="file.editMode = false; file.notes = file.oldNotes;"
                                          icon="pi pi-times">
                                  </button>
                                  <button type="button" pButton class="risksponge-button"
                                          (click)="deleteActionPlanAttachment(item, file)" icon="pi pi-trash">
                                  </button>
                                </td>
                              </tr>
                            </ng-template>

                          </p-table>
                          <div *ngIf="!isReadOnly(originalProjectControlItem) && item.value.actionPlanId">
                            <label for="{{'fileBlobThree' + originalProjectControlItem.projectControlItemId}}"
                                   class="btn">
                              <i class="pi pi-plus"></i>
                              <input id="{{'fileBlobThree' + originalProjectControlItem.projectControlItemId}}"
                                     type="file"
                                     (change)="AddActionPlanAttachment($event, item)" name="addAttachedFile3"
                                     style="display: none;" />
                            </label>
                          </div>
                        </td>
                      </tr>
                    </ng-template>

                  </p-table>

                  <div>
                    <span (click)="addPlan()" class="pi pi-plus"
                          style="float: none;margin-top:20px;margin-left: 10px;" pTooltip="Create POAM from scratch"
                          tooltipPosition="top"></span><span (click)="addActionPlanTemplate(false)"
                                                             style="float: none;margin-top:20px;margin-left: 10px;"
                                                             pTooltip="Copy text from an existing POAM"
                                                             tooltipPosition="top">
                      <img src="../../../assets/icon/copy-light%20(1).svg"
                           style="height: 14px;vertical-align: baseline;" />
                    </span><span (click)="addActionPlanTemplate(true)"
                                 style="float: none;margin-top:20px;margin-left: 10px;"
                                 pTooltip="Link to an existing POAM"
                                 tooltipPosition="top">
                      <img src="../../../assets/icon/link-regular.svg"
                           style="height: 14px; vertical-align: baseline;" />

                    </span>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[2][4]">
              <mat-expansion-panel-header>
                <mat-panel-title>Workstream</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Workstream -->
              <div class="section-div"
                   *ngIf="tenantPermissions.isWorkstreamsEnabled && projectControlItem.workstreamItems">
                <div *ngFor="let workstreamItem of projectControlItem.workstreamItems">
                  <div style="display:flex;gap:20px;width:100%;">
                    <mat-form-field class="input-section" style="width: 100%">
                      <mat-label>Name</mat-label>
                      <input matInput [(ngModel)]="workstreamItem.wsid" readonly>
                    </mat-form-field>
                    <mat-form-field class="input-section" style="width: 100%">
                      <mat-label>Type</mat-label>
                      <input matInput [(ngModel)]="workstreamItem.type" readonly>
                    </mat-form-field>
                    <mat-form-field class="input-section" style="width: 100%">
                      <mat-label>Due Date</mat-label>
                      <input matInput [value]="workstreamItem.dueDate | date : 'shortDate'" readonly>
                    </mat-form-field>
                  </div>
                  <div style="display:flex;gap:20px;width:100%">
                    <mat-form-field class="input-section" style="width: 100%">
                      <mat-label>Owner</mat-label>
                      <input matInput [value]="workstreamItem.ownerName" readonly />
                    </mat-form-field>
                    <mat-form-field class="input-section" style="width: 100%">
                      <mat-label>Status</mat-label>
                      <input matInput name="status" [value]="workstreamItem.status" readonly>
                    </mat-form-field>
                    <mat-form-field class="input-section" style="width: 100%">
                      <mat-label>Key Resources</mat-label>
                      <input matInput [(ngModel)]="workstreamItem.keyResources" readonly>
                    </mat-form-field>

                  </div>
                  <div style="display:flex;gap:20px;width:100%">
                    <mat-form-field class="textarea-section" style="width: 100%">
                      <mat-label>Description</mat-label>
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="4" [(ngModel)]="workstreamItem.description" readonly></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
      @if (criteriaItems.length && tenantPermissions.isAutonomyEnabled) {
        <mat-tab label="Criteria">
          <div class="section"></div>
          <mat-accordion [multi]="true" class="noPadding">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>Criteria</mat-panel-title>
              </mat-expansion-panel-header>
              <div style="display: flex; justify-content: space-between; margin-bottom: 20px; padding: 15px 24px 16px; border-top: 1px solid lightgray; border-bottom: 1px solid orange;">
                <div>
                  <div style="font-size: 1.5em">CRITERIA MET</div>
                  <div style="font-size: 1.25em">{{criteriaItemsMet}}/{{criteriaItems.length}}</div>
                </div>
                <div>
                  <div style="font-size: 1.5em">CONTROL SCORE</div>
                  <div style="font-size: 1.25em">{{ criteriaSum }}/{{ criteriaTotalSum }}</div>
                  <div style="max-width: 100%; border-radius: 2px; height: 6px; border: 2px solid orange; position: relative;">
                    <div style="position: absolute; left: 0; top: 0; height: 2px; background-color: orange; max-width: 100%;" [ngStyle]="{width: (criteriaSum / criteriaTotalSum * 100) + '%'}"></div>
                  </div>
                </div>
              </div>
              <div style="padding: 16px 0;">
                @for (criteria of criteriaItems; track criteria.text) {
                  <div style="display: flex; justify-content: space-between; padding: 5px 24px; border-bottom: 1px solid lightgray;">
                    <div>{{criteria.text}}</div>
                    <div>
                      <mat-form-field>
                        <mat-label>Score</mat-label>
                        <input matInput [(ngModel)]="criteria.userValue" (change)="refreshCriteria()" />
                      </mat-form-field>
                    </div>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-tab>
      }
      <mat-tab label="Artifacts & Evidence">
        <div class="section">
          <mat-accordion [multi]="true">
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[3][0]">
              <mat-expansion-panel-header>
                <mat-panel-title> Evidence</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Evidence -->
              <div class="sections">
                <div style="display: flex; flex-direction: row;">
                  <div style="margin-right: 20px;">
                    <mat-checkbox [(ngModel)]="originalProjectControlItem.evidenceNotNeeded">
                      Evidence is not
                      required
                    </mat-checkbox>
                  </div>
                  <div style="margin-top: 6px;">
                    <i class="pi pi-refresh" (click)="repeatVisible = !repeatVisible"></i>
                  </div>
                </div>

                <div style="display: flex; flex-direction: row; justify-content: start; align-items: center; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"  *ngIf="repeatVisible">

                  <div style="flex:25%">
                    <mat-form-field>
                      <mat-label>Evidence Owner</mat-label>
                      <mat-select [(ngModel)]="originalProjectControlItem.evidenceOwnerId"
                                  [disabled]="isReadOnly(originalProjectControlItem) && !isManagerUser">
                        <mat-option *ngFor="let user of project.assignedUsers" [value]="user.userId">
                          {{ user.fullName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div style="flex:25%">
                    <mat-form-field>
                      <mat-label>Evidence Frequency</mat-label>
                      <mat-select [(ngModel)]="originalProjectControlItem.evidenceFrequency"
                                  [disabled]="isReadOnly(originalProjectControlItem) && !isManagerUser">
                        <mat-option *ngFor="let rec of evidenceRecurringList" [value]="rec.value">
                          {{ rec.label }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div>
                  <span class="ql-editor"
                        [innerHTML]="addToken(projectControlItem.controlItem.evidenceInstructions) | sanitizeHtml"></span>
                  <p-table *ngIf="originalProjectControlItem.evidences && users"
                           [value]="showAllItems ? originalProjectControlItem.evidences.slice() : originalProjectControlItem.evidences.slice(0,5)"
                           #table>

                    <ng-template pTemplate="header">
                      <tr style="white-space: nowrap;font-weight: bold">
                        <th *ngFor="let col of evidenceCols" [pSortableColumn]="col.field"
                            [ngStyle]="{'width': col.width || 'auto'}">
                          {{ col.header }}
                        </th>
                        <th style="width:20em"></th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-item>
                      <tr [pSelectableRow]="item">
                        <td>
                          {{ item.date | date:'shortDate' }} {{ item.date | date:'shortTime' }}
                        </td>
                        <td style="font-size: 0.75; word-break: break-all">
                          <span *ngIf="item.name?.startsWith('external://')">
                            <ng-container *ngIf="item.editMode">
                              <mat-form-field>
                                <input type="text" matInput [(ngModel)]="item.externalName" />
                              </mat-form-field>
                            </ng-container>
                            <ng-container *ngIf="!item.editMode">
                              {{ item.name?.substring('external://'.length) }}
                            </ng-container>
                          </span>
                          <span
                            *ngIf="!item.name?.startsWith('external://') && !item.name?.startsWith('http://') && !item.name?.startsWith('https://') && !item.name?.startsWith('\\\\')"
                            (click)="DownloadEvidence(item.name)" class="btn btn-link">{{ item.name }}</span>
                          <a
                            *ngIf="!item.name?.startsWith('external://') && (item.name?.startsWith('http://') || item.name?.startsWith('https://') || item.name?.startsWith('\\\\'))"
                            [attr.href]="item.name" target="_blank" class="btn btn-link">{{ item.name }}</a>
                        </td>
                        <td>
                          <span>{{ getFullNameById(item.submitterId) }}</span>
                        </td>
                        <td>
                          <span *ngIf="!item.editMode">{{ item.provider }}</span>
                          <span *ngIf="item.editMode">
                            <mat-form-field style="width: 100%">
                              <input matInput [(ngModel)]="item.provider" (keydown.space)="$event.stopPropagation()" />
                            </mat-form-field>
                          </span>
                        </td>
                        <td>
                          <ng-container *ngIf="item.evidenceCentralLog?.inspectionResults">
                            <ng-container *ngIf="item.evidenceCentralLog?.inspectionResults.length === 0">
                              No Findings
                            </ng-container>
                            <div *ngIf="item.evidenceCentralLog?.inspectionResults.length > 0"
                                 style="cursor: pointer;text-decoration: underline;"
                                 (click)="item.evidenceCentralLog.showDetails = !item.evidenceCentralLog.showDetails">
                              Findings
                            </div>
                            <ng-container *ngIf="item.evidenceCentralLog?.showDetails">
                              <div *ngFor="let result of item.evidenceCentralLog?.inspectionResults">
                                {{format(result.condition.operator, result.condition.path, result.condition.value, result.result)}}
                              </div>
                            </ng-container>
                          </ng-container>
                        </td>
                        <td>
                          <span *ngIf="!item.editMode">{{ item.notes }}</span>
                          <span *ngIf="item.editMode">
                            <mat-form-field style="width: 100%">
                              <input matInput [(ngModel)]="item.notes" (keydown.space)="$event.stopPropagation()" />
                            </mat-form-field>
                          </span>
                        </td>
                        <td>
                          @if (isViewable(item)) {
                            <button type="button" pButton class="risksponge-button" icon="pi pi-eye" (click)="viewEvidence(item)"></button>
                          }
                          <button *ngIf="!item.editMode" type="button" pButton class="risksponge-button"
                                  (click)="item.editMode = true; item.oldNotes = item.notes" icon="pi pi-pencil">
                          </button>
                          <button *ngIf="item.editMode" type="button" pButton class="risksponge-button"
                                  (click)="item.editMode = false; saveEvidence(item)" icon="pi pi-save">
                          </button>
                          <button *ngIf="item.editMode" type="button" pButton class="risksponge-button"
                                  (click)="item.editMode = false; item.notes = item.oldNotes;" icon="pi pi-times">
                          </button>
                          <button type="button" pButton class="risksponge-button" (click)="deleteEvidence(item)"
                                  icon="pi pi-trash">
                          </button>
                          <button type="button" pButton class="risksponge-button" *ngIf="!item.approverId"
                                  (click)="item.approvalMode = !item.approvalMode" icon="pi pi-check">
                          </button>
                          <button type="button" pButton class="risksponge-button" icon="pi pi-clock">
                          </button>
                          <button type="button" pButton class="risksponge-button"
                                  *ngIf="item.approverId && !item.approvalMode" (click)="item.approvalMode = true"
                                  icon="pi pi-thumbs-up">
                          </button>
                          <button type="button" pButton class="risksponge-button"
                                  *ngIf="item.approverId && item.approvalMode" (click)="item.approvalMode = false"
                                  icon="pi pi-arrow-up">
                          </button>
                        </td>
                      </tr>
                      <tr *ngIf="item.approverId || item.approvalMode"
                          style="white-space: nowrap;font-weight: bold;background-color: #ebedf0;">
                        <th colspan="2" style="border: 1px solid #e9e9e9; padding: 0 5px;">Approver</th>
                        <th style="border: 1px solid #e9e9e9; padding: 0 5px;">Approval Status</th>
                        <th colspan="2" style="border: 1px solid #e9e9e9; padding: 0 5px;">Approver Note</th>
                        <th style="border: 1px solid #e9e9e9; padding: 0 5px;"></th>
                      </tr>
                      <tr *ngIf="item.approvalMode">
                        <td colspan="2">
                          <mat-form-field *ngIf="item.submitterId == currentUser.userId">
                            <mat-label></mat-label>
                            <mat-select [(ngModel)]="item.approverId" name="approver">
                              <mat-option *ngFor="let user of users" [value]="user.userId">
                                {{ getFullName(user) }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <span
                            *ngIf="item.submitterId != currentUser.userId">{{ getFullNameById(item.approverId) }}</span>
                        </td>
                        <td>
                          <span *ngIf="item.isApproved && item.endDate" style="margin-left:10px;">
                            Approved on
                            {{
                              item.endDate |
                                date : "shortDate"
                            }}
                          </span><span *ngIf="item.isApproved === false && item.endDate"
                                       style="margin-left:10px;">Rejected on {{ item.endDate | date : "shortDate" }}</span>
                        </td>
                        <td colspan="2">
                          <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput
                                   style="width: 100%;" [(ngModel)]="item.approverNote"
                                   [disabled]="item.approverId != currentUser.userId" />
                          </mat-form-field>
                        </td>
                        <td>
                          <button class="risksponge-button" icon="pi pi-thumbs-up" (click)="saveEvidence(item, true)"
                                  *ngIf="item.approverId == currentUser.userId" pButton></button>
                          <button class="risksponge-button" *ngIf="item.approverId == currentUser.userId"
                                  icon="pi pi-thumbs-down" (click)="saveEvidence(item, false)" pButton></button>
                          <button class="risksponge-button" icon="pi pi-save" (click)="saveEvidence(item, null)"
                                  pButton></button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                  <!-- <button pButton type="button" style="background:transparent;color:black;border:none"
                    label="{{ showAllItems ? 'Show Less' : 'Show More' }}" (click)="toggleShowAllItems()"
                    styleClass="p-button-outlined" *ngIf="originalProjectControlItem.evidences.length > 5">
                  </button> -->
                  <!-- TODO Link to specific Control Item -->
                  <a (click)="openEvidenceArchive()" *ngIf="originalProjectControlItem.evidences.length > 5"
                     style="float: right;color: var(--main-ui-color, orange);cursor: pointer">
                    Evidence Archive
                  </a>

                  <div>
                    <label for="{{'fileBlobTwo' + originalProjectControlItem.projectControlItemId}}" class="btn">
                      <i class="pi pi-plus"></i>
                      <input id="{{'fileBlobTwo' + originalProjectControlItem.projectControlItemId}}" type="file"
                             [(ngModel)]="fileBlob2" (change)="AddEvidence($event)" name="addAttachedFile2"
                             style="display: none;" />
                    </label>
                    <label class="btn" (click)="addLinkEvidence()">
                      <i class="pi pi-external-link"></i>
                    </label>
                    <label class="btn" (click)="addExternalEvidence()">
                      <i class="pi pi-check-circle"></i>
                    </label>
                  </div>
                </div>

              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[3][1]">
              <mat-expansion-panel-header>
                <mat-panel-title> Policies & Procedures</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Policies & Procedures -->
              <div class="sections">
                <div>
                  <mat-checkbox [(ngModel)]="originalProjectControlItem.policyNotNeeded">
                    Policies/Procedures are not
                    required
                  </mat-checkbox>
                </div>
                <div *ngIf="canAddPolicies">
                  <span style="margin-right: 20px; cursor: pointer;" (click)="addPolicy(0)"><span
                    class="fa fa-plus"></span>Policy</span>
                  <span style=" cursor: pointer;" (click)="addPolicy(1)"><span
                    class="fa fa-plus"></span>Procedure</span>
                </div>

                <p-table [value]="selectedPolicies" dataKey="policyId">
                  <ng-template pTemplate="header">
                    <tr>
                      <th colspan="2">Policy</th>
                      <th></th>
                      <th style="width: 110px;"></th>
                      <th style="width: 110px;">OSCAL</th>
                      <th style="width: 110px;">Includes Procedures</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item let-expanded="expanded">
                    <tr>
                      <td style="width:2em;" [pRowToggler]="item">
                        <span>
                          <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                        </span>
                      </td>
                      <td [pRowToggler]="item">{{ item.policy.name }}</td>
                      <td>
                        <ng-container *ngFor="let section of item.policy.popupControlMap">
                          <div>
                            &gt; {{ section.number }}{{ section.subNumber ? ' .' + section.subNumber : '' }}
                            {{ section.title }}
                            {{ section.subTitle }}
                          </div>
                        </ng-container>
                        <div *ngIf="item.isMapped">&gt; Entire Policy</div>
                      </td>
                      <td style="width: 110px;">
                        <span class="pi pi-trash" (click)="removePolicy(item, 0)"></span>
                      </td>
                      <td style="width: 110px;">
                        <mat-checkbox [(ngModel)]="item.isExportedToOscal"></mat-checkbox>
                      </td>
                      <td style="width: 110px;">
                        <mat-checkbox *ngIf="item.isExportedToOscal"
                                      [(ngModel)]="item.isUsedAsProcedure"></mat-checkbox>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="expandedrow" let-item>
                    <tr>
                      <td colspan="5">
                        <div *ngFor="let policySection of item.policy.policySections">
                          <h4 *ngIf="policySection.number || policySection.title">
                            {{ policySection.number }}
                            {{ policySection.title }}<br />
                          </h4>
                          <h5>{{ policySection.subNumber }} {{ policySection.subTitle }}</h5>
                          <div [innerHTML]="addToken(policySection.text) | sanitizeHtml"></div>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                <p-table [value]="selectedProcedures" dataKey="id">
                  <ng-template pTemplate="header">
                    <tr>
                      <th colspan="2">Procedure</th>
                      <th></th>
                      <th style="width: 110px;"></th>
                      <th style="width: 110px;">OSCAL</th>
                      <th style="width: 110px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item let-expanded="expanded">
                    <tr>
                      <td style="width:2em;" [pRowToggler]="item">
                        <span>
                          <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                        </span>
                      </td>
                      <td [pRowToggler]="item">{{ item.policy.name }}</td>
                      <td>
                        <ng-container *ngFor="let section of item.policy.popupControlMap">
                          <div>
                            &gt; {{ section.number }}{{ section.subNumber ? ' .' + section.subNumber : '' }}
                            {{ section.title }}
                            {{ section.subTitle }}
                          </div>
                        </ng-container>
                        <div *ngIf="item.isMapped">&gt; Entire Policy</div>
                      </td>
                      <td style="width: 110px;">
                        <span class="pi pi-trash" (click)="removePolicy(item, 1)"></span>
                      </td>
                      <td style="width: 110px;">
                        <mat-checkbox [(ngModel)]="item.isExportedToOscal"></mat-checkbox>
                      </td>
                      <td style="width: 110px;"></td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="expandedrow" let-item>
                    <tr>
                      <td colspan="5">
                        <div *ngFor="let policySection of item.policy.policySections">
                          <h4 *ngIf="policySection.number || policySection.title">
                            {{ policySection.number }}
                            {{ policySection.title }}<br />
                          </h4>
                          <h5>{{ policySection.subNumber }} {{ policySection.subTitle }}</h5>
                          <div [innerHTML]="addToken(policySection.text) | sanitizeHtml"></div>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>

              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[3][2]">
              <mat-expansion-panel-header>
                <mat-panel-title> Documentation</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Documentation -->
              <div class="sections">
                <span class="ql-editor"
                      [innerHTML]="addToken(projectControlItem.controlItem.documentationInstructions) | sanitizeHtml"></span>
                <p-table *ngIf="originalProjectControlItem.attachments && users"
                         [value]="originalProjectControlItem.attachments" #table>

                  <ng-template pTemplate="header">
                    <tr style="white-space: nowrap;font-weight: bold">
                      <th *ngFor="let col of evidenceCols" [pSortableColumn]="col.field"
                          [ngStyle]="{'width': col.width || 'auto'}">
                        {{ col.header }}
                      </th>
                      <th style="width:10em"></th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                    <tr [pSelectableRow]="item">
                      <td>
                        {{ item.date | date:'shortDate' }}
                      </td>
                      <td>
                        <span style="font-size: 10.4px;"
                              *ngIf="!item.name?.startsWith('http://') && !item.name?.startsWith('https://') && !item.name?.startsWith('\\\\') && !item.name?.startsWith('document://')"
                              (click)="DownloadAttachment(item.name)" class="btn btn-link">{{ item.name }}</span>
                        <a style="font-size: 10.4px;"
                           *ngIf="(item.name?.startsWith('http://') || item.name?.startsWith('https://') || item.name?.startsWith('\\\\')) && !item.name?.startsWith('document://')"
                           [attr.href]="item.name" class="btn btn-link">{{ item.name }}</a>
                        <a style="font-size: 10.4px;"
                           *ngIf="!item.name?.startsWith('http://') && !item.name?.startsWith('https://') && !item.name?.startsWith('\\\\') && item.name?.startsWith('document://')"
                           (click)="DownloadAttachment(item.name.substring('document://'.length), true)"
                           class="btn btn-link">{{ item.fileName }}</a>

                        <span *ngIf="item.editMode">
                          <label for="{{'fileBlobAttachment' + rowIndex}}" class="btn">
                            <i class="pi pi-paperclip"></i>
                            <input id="{{'fileBlobAttachment' + rowIndex}}" type="file" [(ngModel)]="fileBlob1"
                                   (change)="UploadAttachment($event, item)" name="addAttachedFile1"
                                   style="display: none;" />
                          </label>
                          <span (click)="addDocument(item)" style="font-weight: bold;">DL</span>
                        </span>
                      </td>
                      <td>
                        <span>{{ getFullNameById(item.submitterId) }}</span>
                      </td>
                      <td>
                        <span *ngIf="!item.editMode">{{ item.provider }}</span>
                        <span *ngIf="item.editMode">
                          <mat-form-field style="width: 100%">
                            <input matInput [(ngModel)]="item.provider" />
                          </mat-form-field>
                        </span>
                      </td>
                      <td>
                        <span *ngIf="!item.editMode">{{ item.notes }}</span>
                        <span *ngIf="item.editMode">
                          <mat-form-field style="width: 100%">
                            <input matInput [(ngModel)]="item.notes" />
                          </mat-form-field>
                        </span>
                      </td>
                      <td>
                        <button *ngIf="!item.editMode" type="button" pButton class="risksponge-button"
                                (click)="item.editMode = true; item.oldNotes = item.notes" icon="pi pi-pencil">
                        </button>
                        <button *ngIf="item.editMode" type="button" pButton class="risksponge-button"
                                (click)="item.editMode = false; saveAttachment(item)" icon="pi pi-check">
                        </button>
                        <button *ngIf="item.editMode" type="button" pButton class="risksponge-button"
                                (click)="item.editMode = false; item.notes = item.oldNotes;" icon="pi pi-times">
                        </button>
                        <button type="button" pButton class="risksponge-button" (click)="deleteAttachment(item)"
                                icon="pi pi-trash">
                        </button>
                      </td>
                    </tr>

                  </ng-template>

                </p-table>

                <div *ngIf="!isReadOnly(originalProjectControlItem)">
                  <label class="btn" (click)="AddAttachment($event)">
                    <i class="pi pi-plus"></i>
                  </label>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
                                 [(expanded)]="expandedAccordions[3][3]">
              <mat-expansion-panel-header>
                <mat-panel-title> Devices</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Documentation -->
              <div class="sections">
                <p-table *ngIf="originalProjectControlItem.devices && users"
                         [value]="originalProjectControlItem.devices" #table>

                  <ng-template pTemplate="header">
                    <tr style="white-space: nowrap;font-weight: bold">
                      <th *ngFor="let col of deviceCols" [pSortableColumn]="col.field"
                          [ngStyle]="{'width': col.width || 'auto'}">
                        {{ col.header }}
                      </th>
                      <th style="width:10em"></th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                    <tr [pSelectableRow]="item">
                      <td *ngFor="let col of deviceCols" [ngSwitch]="col.field">
                        {{item[col.field]}}
                      </td>
                    </tr>

                  </ng-template>

                </p-table>

              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
      <mat-tab label="Assessment ">
        <div class="section">
          <mat-accordion [multi]="true">
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)" *ngIf="assessmentObjectives?.length">
              <mat-expansion-panel-header>
                <mat-panel-title>Objectives</mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <div *ngFor="let assessmentObjective of assessmentObjectives; let i = index">
                  <mat-label>Objective {{i + 1}}: {{assessmentObjective}}</mat-label>
                  <div>
                    <mat-label>Findings/Notes <span class="pi pi-pencil cursor-pointer"
                                                    (click)="visibility['findingsNotesEdit' + i] = !visibility['findingsNotesEdit' + i]"></span>
                    <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(i)"></span>
                    </mat-label>
                    <div>
                      <div class="Summary"
                           *ngIf="!visibility['findingsNotesEdit' + i]"
                           [innerHTML]="addToken(originalProjectControlItem.findingsNotesList[i]) | sanitizeHtml"></div>
                      <p-editor matInput
                                *ngIf="visibility['findingsNotesEdit' + i]"
                                type="text"
                                name="references" [(ngModel)]="originalProjectControlItem.findingsNotesList[i]"
                                #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                        <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                          <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                        </p-header>
                      </p-editor>
                    </div>
                  </div>
                  <div>
                    <mat-label>Recommendations <span class="pi pi-pencil"
                                                    (click)="visibility['recommendations' + i] = !visibility['recommendations' + i]"></span>
                      <span class="pi pi-list cursor-pointer" (click)="selectRecommendations(i)"></span>
                    </mat-label>
                    <div>
                      <div class="Summary"
                           *ngIf="!visibility['recommendations' + i]"
                           [innerHTML]="addToken(originalProjectControlItem.recommendationsList[i]) | sanitizeHtml"></div>
                      <p-editor matInput
                                *ngIf="visibility['recommendations' + i]"
                                type="text"
                                name="references" [(ngModel)]="originalProjectControlItem.recommendationsList[i]"
                                #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                        <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                          <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                        </p-header>
                      </p-editor>
                    </div>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header>
                <mat-panel-title> INT Assessment</mat-panel-title>
                <i style="color: #000000; margin-right: 10px;" class="pi pi-download"
                   (click)="downloadAssessmentNotes(originalProjectControlItem.projectControlItemId, 'INT')"></i>
              </mat-expansion-panel-header>
              <!-- INT Assessment -->
              <div [formGroup]="assessmentNoteForm" class="sections">
                <div formArrayName="assessmentNotes">
                  <p-table [value]="assessmentNoteForm.controls.assessmentNotes.controls"
                           dataKey="value.assessmentNoteId" #table [expandedRowKeys]="expanded">
                    <ng-template pTemplate="header">
                      <tr style="white-space: nowrap;font-weight: bold">
                        <th style="width:5em"></th>
                        <th *ngFor="let col of assessmentNoteCols" [pSortableColumn]="col.field"
                            [ngStyle]="{'width': col.width || 'auto'}">
                          {{ col.header }}
                        </th>
                        <th style="width:5em"></th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                                 let-columns="columns">
                      <tr [pRowToggler]="item">
                        <td style="width:5em;">
                          <span>
                            <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                          </span>
                        </td>
                        <td>A{{ item.value.assessmentNoteId }}</td>
                        <td>{{ item.value.date | date: 'shortDate' }}</td>
                        <td><div [innerHTML]="item.value.finding"></div></td>
                        <td>{{ item.value.name }}</td>
                        <td>{{ item.value.title }}</td>
                        <td>
                          <span *ngIf="canEditAssessmentNotes" (click)="removeAssessmentNote(rowIndex)"
                                class="pi pi-trash"></span>
                        </td>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex">
                      <tr style="font-size: 13px; background-color: #fff">
                        <td [formGroupName]="rowIndex" colspan="6">
                          <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">
                            <div style="display: flex; gap: 20px; margin-top: 10px;">
                              <mat-form-field class="input-section" style="width:300px;">
                                <mat-label>Assessment Method</mat-label>
                                <input matInput name="assessmentMethod" formControlName="assessmentMethod"
                                       [disabled]="isReadOnly(originalProjectControlItem) && canEditAssessmentNotes"
                                       required>
                              </mat-form-field>
                              <mat-form-field class="input-section" style="width:300px;">
                                <mat-label>Assessment Results</mat-label>
                                <mat-select name="assessmentResults" formControlName="assessmentResults"
                                            [disabled]="isReadOnly(originalProjectControlItem) && canEditAssessmentNotes">
                                  <mat-option value="0">Satisfactory</mat-option>
                                  <mat-option value="1">Deficiency</mat-option>
                                  <mat-option value="2">Pending</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>

                          <div>
                            <div>
                              <mat-label>Findings <span class="pi pi-pencil cursor-pointer"
                                                              (click)="visibility.finding = !visibility.finding"></span>
                                <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'finding', item)"></span>
                              </mat-label>
                              <div>
                                <div class="Summary"
                                     *ngIf="!visibility.finding"
                                     [innerHTML]="addToken(item.value.finding) | sanitizeHtml"></div>
                                <p-editor matInput
                                          *ngIf="visibility.finding"
                                          type="text"
                                          name="references"
                                          formControlName="finding"
                                          [disabled]="isReadOnly(originalProjectControlItem) && canEditAssessmentNotes">
                                  <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                                    <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                                    <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                                    <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                                    <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                                    <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                                  </p-header>
                                </p-editor>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div>
                              <mat-label>Recommendations <span class="pi pi-pencil cursor-pointer"
                                                        (click)="visibility.recommendations = !visibility.recommendations"></span>
                                <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'recommendations', item)"></span>
                              </mat-label>
                              <div>
                                <div class="Summary"
                                     *ngIf="!visibility.recommendations"
                                     [innerHTML]="addToken(item.value.recommendations) | sanitizeHtml"></div>
                                <p-editor matInput
                                          *ngIf="visibility.recommendations"
                                          type="text"
                                          name="references"
                                          formControlName="recommendations"
                                          [disabled]="isReadOnly(originalProjectControlItem) && canEditAssessmentNotes">
                                  <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                                    <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                                    <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                                    <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                                    <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                                    <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                                  </p-header>
                                </p-editor>
                              </div>
                            </div>
                          </div>

                          <div style="display: flex; gap: 20px;">

                            <mat-form-field class="input-section" style="width:300px;">
                              <mat-label>Name</mat-label>
                              <input matInput name="name" formControlName="name"
                                     [disabled]="isReadOnly(originalProjectControlItem) && canEditAssessmentNotes"
                                     required>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:300px;">
                              <mat-label>Title</mat-label>
                              <input matInput name="title" formControlName="title"
                                     [disabled]="isReadOnly(originalProjectControlItem) && canEditAssessmentNotes"
                                     required>
                            </mat-form-field>

                            <mat-form-field class="input-section" style="width:300px;">
                              <mat-label>People Interviewed</mat-label>
                              <input matInput formControlName="peopleInterviewed">
                            </mat-form-field>

                          </div>

                          <div style="display: flex; gap: 20px;">
                            <mat-form-field class="input-section" style="width:300px;">
                              <mat-label>Date</mat-label>
                              <input matInput [matDatepicker]="dateControl" name="date" formControlName="date"
                                     [disabled]="isReadOnly(originalProjectControlItem) && canEditAssessmentNotes"
                                     required>
                              <mat-datepicker-toggle matSuffix [for]="dateControl"></mat-datepicker-toggle>
                              <mat-datepicker #dateControl></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:300px;">
                              <mat-label>Status</mat-label>
                              <mat-select class="example-margin" formControlName="status">
                                <mat-option [value]="0">{{ assessmentNoteStatuses[0] }}</mat-option>
                                <mat-option [value]="1">{{ assessmentNoteStatuses[1] }}</mat-option>
                                <mat-option [value]="2">{{ assessmentNoteStatuses[2] }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field class="input-section" style="width:300px;">
                              <mat-label>Interview Dates</mat-label>
                              <input matInput [matDatepicker]="InterviewDatePicker"
                                     formControlName="interviewDate">
                              <mat-datepicker-toggle matSuffix [for]="InterviewDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #InterviewDatePicker></mat-datepicker>
                            </mat-form-field>


                          </div>

                          <div style="display: flex; gap: 20px;">

                            <mat-slide-toggle class="example-margin" name="typeBool" formControlName="isVisible">
                              Visible in Assessment View
                            </mat-slide-toggle>
                            <mat-slide-toggle class="example-margin" name="typeBool" formControlName="isVisibleInSsp">
                              Visible in SSP
                            </mat-slide-toggle>
                          </div>

                          <div style="font-size: 14px;color:#cccccc;">Attachments</div>
                          <p-table *ngIf="item.value.attachments && users" [value]="item.value.attachments" #table>
                            <ng-template pTemplate="header">
                              <tr style="white-space: nowrap;font-weight: bold">
                                <th *ngFor="let col of assessmentNoteAttachmentCols" [pSortableColumn]="col.field"
                                    [ngStyle]="{'width': col.width || 'auto'}">
                                  {{ col.header }}
                                </th>
                                <th style="width:10em" *ngIf="canEditAssessmentNotes"></th>
                              </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-file>
                              <tr [pSelectableRow]="file">
                                <td>{{ file.date | date:'shortDate' }}</td>
                                <td>
                                  <span
                                    *ngIf="!file.name?.startsWith('http://') && !file.name?.startsWith('https://') && !file.name?.startsWith('\\\\')"
                                    (click)="DownloadAttachment(file.name)" class="btn btn-link">{{ file.name }}</span>
                                  <a
                                    *ngIf="file.name?.startsWith('http://') || file.name?.startsWith('https://') || file.name?.startsWith('\\\\')"
                                    target="_blank" [attr.href]="file.name" class="btn btn-link">{{ file.name }}</a>
                                </td>
                                <td>
                                  <span *ngIf="!file.editMode">{{ file.notes }}</span>
                                  <span *ngIf="file.editMode">
                                    <mat-form-field style="width: 100%">
                                      <input matInput (change)="file.notes=$event.target['value']" />
                                    </mat-form-field>
                                  </span>
                                </td>
                                <td *ngIf="canEditAssessmentNotes">
                                  <button *ngIf="!file.editMode" type="button" pButton class="risksponge-button"
                                          (click)="file.editMode = true; file.oldNotes = file.notes"
                                          icon="pi pi-pencil"></button>
                                  <button *ngIf="file.editMode" type="button" pButton class="risksponge-button"
                                          (click)="file.editMode = false; saveAssessmentAttachment(file)"
                                          icon="pi pi-check"></button>
                                  <button *ngIf="file.editMode" type="button" pButton class="risksponge-button"
                                          (click)="file.editMode = false; file.notes = file.oldNotes;"
                                          icon="pi pi-times"></button>
                                  <button *ngIf="canEditAssessmentNotes" type="button" pButton class="risksponge-button"
                                          (click)="deleteAssessmentAttachment(item, file)" icon="pi pi-trash"></button>
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                          <div
                            *ngIf="!isReadOnly(originalProjectControlItem) && item.value.assessmentNoteId && canEditAssessmentNotes">
                            <label for="{{'fileBlobThree' + originalProjectControlItem.projectControlItemId}}"
                                   class="btn">
                              <i class="pi pi-plus"></i>
                              <input id="{{'fileBlobThree' + originalProjectControlItem.projectControlItemId}}"
                                     type="file"
                                     (change)="AddAssessmentAttachment($event, item)" name="addAttachedFile3"
                                     style="display: none;" />
                            </label>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <div>
                    <span (click)="addAssessment()" *ngIf="canEditAssessmentNotes" class="pi pi-plus"
                          style="float: none;margin-top:20px;margin-left: 10px;"></span>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header>
                <mat-panel-title> 3P Security Assessment</mat-panel-title>
                <i style="color: #000000; margin-right: 10px;" class="pi pi-download"
                   (click)="downloadAssessmentNotes(originalProjectControlItem.projectControlItemId, 'Security')"></i>
              </mat-expansion-panel-header>
              <!-- 3P Security Assessment -->
              <div class="sections" class="securityAssessmentVisible">
                <div style="display: flex; gap: 20px">
                  <mat-form-field class="textarea-section" style="width:300px;">
                    <mat-label>Previous Tested</mat-label>
                    <input matInput [(ngModel)]="originalProjectControlItem.previousTested">
                  </mat-form-field>
                </div>
                <div style="display: flex; gap: 40px">
                  <mat-form-field class="textarea-section" style="width:50%;">
                    <mat-label>Assessment Objective</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text"
                              [(ngModel)]="originalProjectControlItem.assessmentObjective"
                              #description="ngModel">
                                                  </textarea>
                  </mat-form-field>
                  <mat-form-field class="textarea-section" style="width:50%;">
                    <mat-label>Potential Assessment Methods and Objects</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text"
                              [(ngModel)]="originalProjectControlItem.potentialAssessmentMethodsandObjects"
                              #description="ngModel">
                        </textarea>
                  </mat-form-field>
                </div>


                <div style="display: flex; gap: 40px;">

                  <mat-form-field class="textarea-section" style="width:50%;">
                    <mat-label>Assessment Method</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text"
                              [(ngModel)]="originalProjectControlItem.assessmentMethod_"
                              #description="ngModel">
                     </textarea>
                  </mat-form-field>

                  <mat-form-field class="textarea-section" style="width:50%">
                    <mat-label>Assessment Artifacts</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text"
                              [(ngModel)]="originalProjectControlItem.assessmentArtifacts_"
                              #description="ngModel">
                                 </textarea>
                  </mat-form-field>
                </div>
                <div style="display: flex; gap: 40px;">
                  <div style="width: 50%">
                    <div>
                      <mat-label>Assessment Finding <span class="pi pi-pencil cursor-pointer"
                                                      (click)="visibility.assessmentFinding_ = !visibility.assessmentFinding_"></span>
                        <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'assessmentFinding_')"></span>
                      </mat-label>
                      <div>
                        <div class="Summary"
                             *ngIf="!visibility.assessmentFinding_"
                             [innerHTML]="addToken(originalProjectControlItem.assessmentFinding_) | sanitizeHtml"></div>
                        <p-editor matInput
                                  *ngIf="visibility.assessmentFinding_"
                                  type="text"
                                  name="references" [(ngModel)]="originalProjectControlItem.assessmentFinding_"
                                  #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                          <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                            <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                            <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                            <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                            <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                            <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                          </p-header>
                        </p-editor>
                      </div>
                    </div>
                  </div>
                  <mat-form-field class="textarea-section" style="width:50%;">
                    <mat-label>Control Weaknesses</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="controlWeaknesses_"
                              [(ngModel)]="originalProjectControlItem.controlWeaknesses_" #description="ngModel">
                                                                  </textarea>
                  </mat-form-field>
                </div>

                <div style="width: 50%;">
                  <div>
                    <mat-label>Further Discussion <span class="pi pi-pencil cursor-pointer"
                                                        (click)="visibility.furtherDiscussion = !visibility.furtherDiscussion"></span>
                      <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'furtherDiscussion')"></span>
                    </mat-label>
                    <div>
                      <div class="Summary"
                           *ngIf="!visibility.furtherDiscussion"
                           [innerHTML]="addToken(originalProjectControlItem.furtherDiscussion) | sanitizeHtml"></div>
                      <p-editor matInput
                                *ngIf="visibility.furtherDiscussion"
                                type="text"
                                name="references" [(ngModel)]="originalProjectControlItem.furtherDiscussion"
                                #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                        <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                          <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                        </p-header>
                      </p-editor>
                    </div>
                  </div>
                </div>
                <div style="width: 50%;">
                  <div>
                    <mat-label>Assessment Results <span class="pi pi-pencil cursor-pointer"
                                                        (click)="visibility.assessmentResults_ = !visibility.assessmentResults_"></span>
                      <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'assessmentResults_')"></span>
                    </mat-label>
                    <div>
                      <div class="Summary"
                           *ngIf="!visibility.assessmentResults_"
                           [innerHTML]="addToken(originalProjectControlItem.assessmentResults_) | sanitizeHtml"></div>
                      <p-editor matInput
                                *ngIf="visibility.assessmentResults_"
                                type="text"
                                name="references" [(ngModel)]="originalProjectControlItem.assessmentResults_"
                                #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                        <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                          <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                        </p-header>
                      </p-editor>
                    </div>
                  </div>
                </div>
                <div style="width: 50%;">
                  <div>
                    <mat-label>Suggested Mitigation <span class="pi pi-pencil cursor-pointer"
                                                        (click)="visibility.suggestedMitigation_ = !visibility.suggestedMitigation_"></span>
                      <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'suggestedMitigation_')"></span>
                    </mat-label>
                    <div>
                      <div class="Summary"
                           *ngIf="!visibility.suggestedMitigation_"
                           [innerHTML]="addToken(originalProjectControlItem.suggestedMitigation_) | sanitizeHtml"></div>
                      <p-editor matInput
                                *ngIf="visibility.suggestedMitigation_"
                                type="text"
                                name="references" [(ngModel)]="originalProjectControlItem.suggestedMitigation_"
                                #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                        <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                          <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                        </p-header>
                      </p-editor>
                    </div>
                  </div>
                </div>
                <div style="display: flex; gap: 20px;">
                  <mat-form-field class="input-section" style="width:12%;">
                    <mat-label>Assessor Name</mat-label>
                    <input matInput [(ngModel)]="originalProjectControlItem.assessorInitials_">
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:12%;">
                    <mat-label>Assessment Date</mat-label>
                    <input matInput [matDatepicker]="AssessmentDatePicker" name="AssessmentDate"
                           [(ngModel)]="originalProjectControlItem.assessmentDate_"
                           (dateChange)="onAssessmentDateChanged($event)">
                    <mat-datepicker-toggle matSuffix [for]="AssessmentDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #AssessmentDatePicker></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:12%;">
                    <mat-label>People Interviewed</mat-label>
                    <input matInput [(ngModel)]="originalProjectControlItem.assessmentPeopleInterviewed">
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:12%;">
                    <mat-label>Assessment Date</mat-label>
                    <input matInput [matDatepicker]="AssessmentInterviewDatePicker"
                           [(ngModel)]="originalProjectControlItem.assessmentInterviewDate">
                    <mat-datepicker-toggle matSuffix [for]="AssessmentInterviewDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #AssessmentInterviewDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>

              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header>
                <mat-panel-title> 3P Risk Assessment</mat-panel-title>
                <i style="color: #000000; margin-right: 10px;" class="pi pi-download"
                   (click)="downloadAssessmentNotes(originalProjectControlItem.projectControlItemId, 'Risk')"></i>

              </mat-expansion-panel-header>
              <!-- 3P Risk Assessment -->
              <div class="sections" class="riskAssessmentVisible">
                <div style="display: flex; gap: 20px; width:75%">

                  <mat-form-field class="input-section" style="width:33%;">
                    <mat-label style="margin-top:6px">FedRAMP Risk Exposure</mat-label>
                    <mat-select [(ngModel)]="originalProjectControlItem.fedRAMPRiskExposure" name="fedRAMPRiskExposure"
                                disabled="{{isReadOnly(originalProjectControlItem)}}" style="margin-top:6px">
                      <mat-option [value]="0">None</mat-option>
                      <mat-option [value]="1">Low</mat-option>
                      <mat-option [value]="2">Medium</mat-option>
                      <mat-option [value]="3">High</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="textarea-section" style="width:33%;">
                    <mat-label>CVSS Score</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="cvssScore_"
                              [(ngModel)]="originalProjectControlItem.cvssScore_" #description="ngModel">
                                                            </textarea>
                  </mat-form-field>
                  <mat-form-field class="textarea-section" style="width:33%;">
                    <mat-label>SANS CSC Cross Ref</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="sanscscCrossRef_"
                              [(ngModel)]="originalProjectControlItem.sanscscCrossRef_" #description="ngModel">
                                                                                </textarea>
                  </mat-form-field>
                </div>


                <!-- <div style="display: flex; gap: 20px;">

                  <mat-form-field class="textarea-section" style="width:75%;">
                    <mat-label>Risk Statement</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                      type="text" name="riskStatement_"
                      [(ngModel)]="originalProjectControlItem.riskStatement_" #description="ngModel">
                                                            </textarea>
                  </mat-form-field>
                </div> -->

                <div style="width: 50%">
                  <div>
                    <mat-label>Risk Statement <span class="pi pi-pencil cursor-pointer"
                                                          (click)="visibility.riskStatement_ = !visibility.riskStatement_"></span>
                      <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'riskStatement_')"></span>
                    </mat-label>
                    <div>
                      <div class="Summary"
                           *ngIf="!visibility.riskStatement_"
                           [innerHTML]="addToken(originalProjectControlItem.riskStatement_) | sanitizeHtml"></div>
                      <p-editor matInput
                                *ngIf="visibility.riskStatement_"
                                type="text"
                                name="references" [(ngModel)]="originalProjectControlItem.riskStatement_"
                                #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                        <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                          <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                        </p-header>
                      </p-editor>
                    </div>
                  </div>
                </div>


                <div style="width: 50%;">
                  <div>
                    <mat-label>Description of Threat <span class="pi pi-pencil cursor-pointer"
                                                    (click)="visibility.threat_ = !visibility.threat_"></span>
                      <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'threat_')"></span>
                    </mat-label>
                    <div>
                      <div class="Summary"
                           *ngIf="!visibility.threat_"
                           [innerHTML]="addToken(originalProjectControlItem.threat_) | sanitizeHtml"></div>
                      <p-editor matInput
                                *ngIf="visibility.threat_"
                                type="text"
                                name="references" [(ngModel)]="originalProjectControlItem.threat_"
                                #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                        <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                          <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                          <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                          <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                        </p-header>
                      </p-editor>
                    </div>
                  </div>
                </div>

                <div style="display: flex; gap: 20px;">
                  <mat-form-field class="textarea-section">
                    <mat-label>Impact Confidentiality</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="impactConfidentiality_"
                              [(ngModel)]="originalProjectControlItem.impactConfidentiality_" #description="ngModel">
           </textarea>
                  </mat-form-field>
                  <mat-form-field class="textarea-section">
                    <mat-label>Impact Integrity</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="impactIntegrity_"
                              [(ngModel)]="originalProjectControlItem.impactIntegrity_" #description="ngModel">
                                                            </textarea>
                  </mat-form-field>
                  <mat-form-field class="textarea-section">
                    <mat-label>Impact Availability</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="impactAvailability_"
                              [(ngModel)]="originalProjectControlItem.impactAvailability_" #description="ngModel">
                       </textarea>
                  </mat-form-field>
                </div>


                <div style="display: flex; gap: 20px;">
                  <mat-form-field class="textarea-section" style="width:15%;">
                    <mat-label>Likelihood</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="likelihood_"
                              [(ngModel)]="originalProjectControlItem.likelihood_" #description="ngModel">
                     </textarea>
                  </mat-form-field>

                  <mat-form-field class="textarea-section" style="width:15%;">
                    <mat-label>Impact</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="impact_"
                              [(ngModel)]="originalProjectControlItem.impact_" #description="ngModel">
                                                            </textarea>
                  </mat-form-field>
                  <mat-form-field class="textarea-section" style="width:15%;">
                    <mat-label>Risk Score</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="riskScore_"
                              [(ngModel)]="originalProjectControlItem.riskScore_" #description="ngModel">
                                                            </textarea>
                  </mat-form-field>

                  <mat-form-field class="textarea-section" style="width:55%;">
                    <mat-label>Risk</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="risk_"
                              [(ngModel)]="originalProjectControlItem.risk_"
                              #description="ngModel">
                    </textarea>
                  </mat-form-field>
                </div>
                <div style="display: flex; gap: 20px;">
                  <mat-form-field class="input-section" style="width:12%;">
                    <mat-label>Assessor Name</mat-label>
                    <input matInput [(ngModel)]="originalProjectControlItem.riskAssessorName">
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:12%;">
                    <mat-label>Assessment Date</mat-label>
                    <input matInput [matDatepicker]="riskAssessmentDate" name="riskAssessmentDate"
                           [(ngModel)]="originalProjectControlItem.riskAssessmentDate"
                           (dateChange)="onAssessmentDateChanged($event)">
                    <mat-datepicker-toggle matSuffix [for]="AssessmentDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #riskAssessmentDate></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:12%;">
                    <mat-label>People Interviewed</mat-label>
                    <input matInput [(ngModel)]="originalProjectControlItem.riskAssessmentPeopleInterviewed">
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:12%;">
                    <mat-label>Assessment Date</mat-label>
                    <input matInput [matDatepicker]="riskAssessmentInterviewDate"
                           [(ngModel)]="originalProjectControlItem.riskAssessmentInterviewDate">
                    <mat-datepicker-toggle matSuffix [for]="riskAssessmentInterviewDate"></mat-datepicker-toggle>
                    <mat-datepicker #riskAssessmentInterviewDate></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header>
                <mat-panel-title> Area Specific</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="section-div" *ngIf="isNotHiddenForComplianceArea">
                <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                  <div style="flex:49%">
                    <mat-form-field class="textarea-section">
                      <mat-label>Risk Weight</mat-label>
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="2" type="text" name="riskWeight"
                                [(ngModel)]="originalProjectControlItem.riskWeight" #riskWeight="ngModel"
                                disabled="{{isReadOnly(originalProjectControlItem)}}">
                            </textarea>
                    </mat-form-field>
                  </div>

                  <div style="flex:2%"></div>

                  <div style="flex:49%">
                    <mat-form-field class="textarea-section">
                      <mat-label>Applicable To System</mat-label>
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="10" type="text" name="applicableToSystem_"
                                [(ngModel)]="originalProjectControlItem.applicableToSystem_" #description="ngModel">
                                                </textarea>
                    </mat-form-field>
                  </div>


                </div>
                <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                  <div style="flex:100%">
                    <div>
                      <mat-label>Control Implementation / Rational for Control Scoping <span class="pi pi-pencil cursor-pointer"
                                                             (click)="visibility.controlImplementation_RationalforControlScoping_ = !visibility.controlImplementation_RationalforControlScoping_"></span>
                        <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'controlImplementation_RationalforControlScoping_')"></span>
                      </mat-label>
                      <div>
                        <div class="Summary"
                             *ngIf="!visibility.controlImplementation_RationalforControlScoping_"
                             [innerHTML]="addToken(originalProjectControlItem.controlImplementation_RationalforControlScoping_) | sanitizeHtml"></div>
                        <p-editor matInput
                                  *ngIf="visibility.controlImplementation_RationalforControlScoping_"
                                  type="text"
                                  name="references" [(ngModel)]="originalProjectControlItem.controlImplementation_RationalforControlScoping_"
                                  #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                          <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                            <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                            <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                            <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                            <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                            <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                          </p-header>
                        </p-editor>
                      </div>
                    </div>
                    </div>
                </div>
                <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                  <div style="flex:49%">
                    <mat-form-field class="textarea-section">
                      <mat-label>Tested in FY16</mat-label>
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="10" type="text" name="testedInFY16_"
                                [(ngModel)]="originalProjectControlItem.testedInFY16_" #description="ngModel">
                      </textarea>
                    </mat-form-field>
                  </div>
                  <div style="flex:2%"></div>

                  <div style="flex:49%">
                    <mat-form-field class="textarea-section">
                      <mat-label>Tested in FY17</mat-label>
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="10" type="text" name="testedInFY17_"
                                [(ngModel)]="originalProjectControlItem.testedInFY17_" #description="ngModel">
                        </textarea>
                    </mat-form-field>
                  </div>
                </div>

                <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                  <div style="flex:49%">
                    <mat-form-field class="textarea-section">
                      <mat-label>Tested in FY18</mat-label>
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="10" type="text" name="testedInFY18_"
                                [(ngModel)]="originalProjectControlItem.testedInFY18_" #description="ngModel">
                                                        </textarea>
                    </mat-form-field>
                  </div>

                  <div style="flex:2%"></div>

                  <div style="flex:49%">
                    <mat-form-field class="textarea-section">
                      <mat-label>Tested in FY19</mat-label>
                      <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="10" type="text" name="testedInFY19_"
                                [(ngModel)]="originalProjectControlItem.testedInFY19_" #description="ngModel">
                      </textarea>
                    </mat-form-field>
                  </div>
                </div>
                <div style="flex:49%">
                  <mat-form-field class="input-section">
                    <mat-label>Priority</mat-label>
                    <input matInput name="priority" [(ngModel)]="originalProjectControlItem.priority"
                           [disabled]="isReadOnly(originalProjectControlItem)">

                  </mat-form-field>
                </div>

                <div style="display: flex; flex-direction: column;">
                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                    <div style="flex:49%">
                      <mat-checkbox class="example-margin" [(ngModel)]="originalProjectControlItem.fP199Low"
                                    name="fP199Low" [disabled]="isReadOnly(originalProjectControlItem)">
                        FP199 Low
                      </mat-checkbox>
                    </div>

                    <div style="flex:49%">
                      <mat-checkbox class="example-margin" [(ngModel)]="originalProjectControlItem.fP199Moderate"
                                    name="fP199Moderate" [disabled]="isReadOnly(originalProjectControlItem)">
                        FP199 Moderate
                      </mat-checkbox>
                    </div>
                  </div>
                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                    <div style="flex:49%">
                      <mat-checkbox class="example-margin" [(ngModel)]="originalProjectControlItem.fP199High"
                                    name="fP199High" [disabled]="isReadOnly(originalProjectControlItem)">
                        FP199 High
                      </mat-checkbox>
                    </div>
                    <div style="flex:49%">
                      <mat-checkbox class="example-margin" [(ngModel)]="originalProjectControlItem.fedRAMPLow"
                                    name="fedRAMPLow" [disabled]="isReadOnly(originalProjectControlItem)">
                        FedRAMP Low
                      </mat-checkbox>
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">
                    <div style="flex:49%">
                      <mat-checkbox class="example-margin" [(ngModel)]="originalProjectControlItem.fedRAMPModerate"
                                    name="fedRAMPModerate" [disabled]="isReadOnly(originalProjectControlItem)">
                        FedRAMP Moderate
                      </mat-checkbox>
                    </div>

                    <div style="flex:49%"></div>
                  </div>

                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                    <div style="display: flex; flex-direction: column; flex:49%">
                      <div>
                        <mat-label>Fed RAMP Continuous Monitoring Template <span class="pi pi-pencil cursor-pointer"
                                                                                               (click)="visibility.fedRAMPContinuousMonitoringTemplate = !visibility.fedRAMPContinuousMonitoringTemplate"></span>
                          <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'fedRAMPContinuousMonitoringTemplate')"></span>
                        </mat-label>
                        <div>
                          <div class="Summary"
                               *ngIf="!visibility.fedRAMPContinuousMonitoringTemplate"
                               [innerHTML]="addToken(originalProjectControlItem.fedRAMPContinuousMonitoringTemplate) | sanitizeHtml"></div>
                          <p-editor matInput
                                    *ngIf="visibility.fedRAMPContinuousMonitoringTemplate"
                                    type="text"
                                    name="references" [(ngModel)]="originalProjectControlItem.fedRAMPContinuousMonitoringTemplate"
                                    #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                            <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                              <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                              <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                              <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                              <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                              <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                            </p-header>
                          </p-editor>
                        </div>
                      </div>
                    </div>

                    <div style="flex:2%; display: flex; flex-direction: column;"></div>

                    <div style="flex:49%">
                      <div>
                        <mat-label>FedRAMP Annual Assessment Guidance <span class="pi pi-pencil cursor-pointer"
                                                                                 (click)="visibility.fedRAMPAnnualAssessmentGuidance = !visibility.fedRAMPAnnualAssessmentGuidance"></span>
                          <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'fedRAMPAnnualAssessmentGuidance')"></span>
                        </mat-label>
                        <div>
                          <div class="Summary"
                               *ngIf="!visibility.fedRAMPAnnualAssessmentGuidance"
                               [innerHTML]="addToken(originalProjectControlItem.fedRAMPAnnualAssessmentGuidance) | sanitizeHtml"></div>
                          <p-editor matInput
                                    *ngIf="visibility.fedRAMPAnnualAssessmentGuidance"
                                    type="text"
                                    name="references" [(ngModel)]="originalProjectControlItem.fedRAMPAnnualAssessmentGuidance"
                                    #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                            <p-header>
                      <span class="ql-formats">
                        <select class="ql-size">
                          <option value="huge">Heading</option>
                          <option value="large">Subheading</option>
                          <option selected></option>
                          <option value="small">Small</option>
                        </select>
                        <select class="ql-font">
                          <option selected="">Sans Serif</option>
                          <option value="serif">Serif</option>
                          <option value="monospace">Monospace</option>
                        </select>
                      </span>
                              <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                        <button class="ql-strike" aria-label="Strike"></button>
                      </span>
                              <span class="ql-formats">
                        <select class="ql-color">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                        <select class="ql-background">
                          <option selected="selected"></option>
                          <option value="#e60000"></option>
                          <option value="#ff9900"></option>
                          <option value="#ffff00"></option>
                          <option value="#008a00"></option>
                          <option value="#0066cc"></option>
                          <option value="#9933ff"></option>
                          <option value="#ffffff"></option>
                          <option value="#facccc"></option>
                          <option value="#ffebcc"></option>
                          <option value="#ffffcc"></option>
                          <option value="#cce8cc"></option>
                          <option value="#cce0f5"></option>
                          <option value="#ebd6ff"></option>
                          <option value="#bbbbbb"></option>
                          <option value="#f06666"></option>
                          <option value="#ffc266"></option>
                          <option value="#ffff66"></option>
                          <option value="#66b966"></option>
                          <option value="#66a3e0"></option>
                          <option value="#c285ff"></option>
                          <option value="#888888"></option>
                          <option value="#a10000"></option>
                          <option value="#b26b00"></option>
                          <option value="#b2b200"></option>
                          <option value="#006100"></option>
                          <option value="#0047b2"></option>
                          <option value="#6b24b2"></option>
                          <option value="#444444"></option>
                          <option value="#5c0000"></option>
                          <option value="#663d00"></option>
                          <option value="#666600"></option>
                          <option value="#003700"></option>
                          <option value="#002966"></option>
                          <option value="#3d1466"></option>
                        </select> <span class="ql-format-separator"></span>
                      </span>
                              <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                        <select title="Text Alignment" class="ql-align">
                          <option selected>Left</option>
                          <option value="center" label="Center"></option>
                          <option value="right" label="Right"></option>
                          <option value="justify" label="Justify"></option>
                        </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                      </span>
                              <span class="ql-formats">
                        <button aria-label="Link" class="ql-link"></button>
                        <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                #el (click)="selectDocument(el)">
                          D
                        </button>
                        <button aria-label="Image" class="ql-image"></button>
                        <button aria-label="Code block" class="ql-code-block"></button>
                      </span>
                              <span class="ql-formats">
                        <button aria-label="Clean" class="ql-clean"></button>
                      </span>
                            </p-header>
                          </p-editor>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                    <div style="flex:100%">
                      <mat-form-field class="textarea-section">
                        <mat-label>Organizational Parameters</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="4" type="text" name="organizationalParameters" cols="60"
                                  [(ngModel)]="originalProjectControlItem.organizationalParameters"
                                  #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                              </textarea>
                      </mat-form-field>
                    </div>

                  </div>


                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                    <div style="flex:49%">
                      <mat-form-field class="textarea-section">
                        <mat-label>Privacy Act</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" name="privacyAct"
                                  [(ngModel)]="originalProjectControlItem.privacyAct" #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                       </textarea>
                      </mat-form-field>
                    </div>

                    <div style="flex:2%"></div>

                    <div style="flex:49%">
                      <mat-form-field class="textarea-section">
                        <mat-label>HIPAA</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" name="hipaa"
                                  [(ngModel)]="originalProjectControlItem.hipaa" #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                                                            </textarea>
                      </mat-form-field>
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                    <div style="flex:49%">
                      <mat-form-field class="textarea-section">
                        <mat-label>OMB / EO / HSPD</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" name="omB_EO_HSPD"
                                  [(ngModel)]="originalProjectControlItem.omB_EO_HSPD" #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                                                            </textarea>
                      </mat-form-field>
                    </div>

                    <div style="flex:2%"></div>

                    <div style="flex:49%">
                      <mat-form-field class="textarea-section">
                        <mat-label>FISCAM</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" name="fiscam"
                                  [(ngModel)]="originalProjectControlItem.fiscam" #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                                                            </textarea>
                      </mat-form-field>
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                    <div style="flex:49%">
                      <mat-form-field class="textarea-section">
                        <mat-label>NISTIR7966</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" name="nistiR7966"
                                  [(ngModel)]="originalProjectControlItem.nistiR7966" #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                                                            </textarea>
                      </mat-form-field>
                    </div>

                    <div style="flex:2%"></div>

                    <div style="flex:49%">
                      <mat-form-field class="textarea-section">
                        <mat-label>Draft 800-171 Rev1</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" name="draft800_171Rev1"
                                  [(ngModel)]="originalProjectControlItem.draft800_171Rev1" #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                                                            </textarea>
                      </mat-form-field>
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                    <div style="flex:49%">
                      <mat-form-field class="textarea-section">
                        <mat-label>FedRAMP</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" name="fedRAMP"
                                  [(ngModel)]="originalProjectControlItem.fedRAMP" #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                                </textarea>
                      </mat-form-field>
                    </div>

                    <div style="flex:2%"></div>

                    <div style="flex:49%">
                      <mat-form-field class="textarea-section">
                        <mat-label>References</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" name="references"
                                  [(ngModel)]="originalProjectControlItem.references" #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                                                            </textarea>
                      </mat-form-field>
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;">

                    <div style="flex:49%">
                      <mat-form-field class="textarea-section">
                        <mat-label>ISO 27001</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" name="isO27001"
                                  [(ngModel)]="originalProjectControlItem.isO27001" #description="ngModel"
                                  [disabled]="isReadOnly(originalProjectControlItem)">
                                                            </textarea>
                      </mat-form-field>
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: column; justify-content: start; align-items: start; ; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;" *ngIf="isNotHiddenForComplianceArea">

                    <label>
                      Potential Assessment Methods and Objects <span class="pi pi-pencil"
                                                                     (click)="originalProjectControlItem.potentialAssessmentMethodsandObjectsEdit = !originalProjectControlItem.potentialAssessmentMethodsandObjectsEdit"></span>
                      <span class="pi pi-list cursor-pointer" (click)="selectFindingsNotes(-1, 'potentialAssessmentMethodsandObjectsEdit')"></span>
                    </label>
                    <div class="Summary" style="width:100%"
                         *ngIf="!originalProjectControlItem.potentialAssessmentMethodsandObjectsEdit"
                         [innerHTML]="addToken(originalProjectControlItem.potentialAssessmentMethodsandObjects) | sanitizeHtml">
                    </div>
                    <p-editor matInput style="width:100%"
                              *ngIf="originalProjectControlItem.potentialAssessmentMethodsandObjectsEdit" type="text"
                              name="references"
                              [(ngModel)]="originalProjectControlItem.potentialAssessmentMethodsandObjects"
                              #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">
                      <p-header>
                        <span class="ql-formats">
                          <select class="ql-size">
                            <option value="huge">Heading</option>
                            <option value="large">Subheading</option>
                            <option selected></option>
                            <option value="small">Small</option>
                          </select>
                          <select class="ql-font">
                            <option selected="">Sans Serif</option>
                            <option value="serif">Serif</option>
                            <option value="monospace">Monospace</option>
                          </select>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-bold" aria-label="Bold"></button>
                          <button class="ql-italic" aria-label="Italic"></button>
                          <button class="ql-underline" aria-label="Underline"></button>
                          <button class="ql-strike" aria-label="Strike"></button>
                        </span>
                        <span class="ql-formats">
                          <select class="ql-color">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                          <select class="ql-background">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-list" value="ordered"></button>
                          <button class="ql-list" value="bullet"></button>
                          <select title="Text Alignment" class="ql-align">
                            <option selected>Left</option>
                            <option value="center" label="Center"></option>
                            <option value="right" label="Right"></option>
                            <option value="justify" label="Justify"></option>
                          </select>
                          <button class="ql-indent" value="-1"></button>
                          <button class="ql-indent" value="+1"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Link" class="ql-link"></button>
                          <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                  #el (click)="selectDocument(el)">
                            D
                          </button>
                          <button aria-label="Image" class="ql-image"></button>
                          <button aria-label="Code block" class="ql-code-block"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Clean" class="ql-clean"></button>
                        </span>
                      </p-header>
                    </p-editor>
                  </div>

                  <div style="display: flex; gap: 20px;">
                    <mat-form-field class="input-section" style="width:12%;">
                      <mat-label>Assessor Name</mat-label>
                      <input matInput [(ngModel)]="originalProjectControlItem.areaAssessorName">
                    </mat-form-field>
                    <mat-form-field class="input-section" style="width:12%;">
                      <mat-label>Assessment Date</mat-label>
                      <input matInput [matDatepicker]="AreaAssessmentDate" name="AreaAssessmentDate"
                             [(ngModel)]="originalProjectControlItem.areaAssessmentDate">
                      <mat-datepicker-toggle matSuffix [for]="AreaAssessmentDate"></mat-datepicker-toggle>
                      <mat-datepicker #AreaAssessmentDate></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="input-section" style="width:12%;">
                      <mat-label>People Interviewed</mat-label>
                      <input matInput [(ngModel)]="originalProjectControlItem.areaAssessmentPeopleInterviewed">
                    </mat-form-field>
                    <mat-form-field class="input-section" style="width:12%;">
                      <mat-label>Assessment Date</mat-label>
                      <input matInput [matDatepicker]="areaAssessmentInterviewDate"
                             [(ngModel)]="originalProjectControlItem.areaAssessmentInterviewDate">
                      <mat-datepicker-toggle matSuffix [for]="areaAssessmentInterviewDate"></mat-datepicker-toggle>
                      <mat-datepicker #areaAssessmentInterviewDate></mat-datepicker>
                    </mat-form-field>
                  </div>

                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Scoring
                </mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Scoring -->
              <div class="sections">
                <div style="display: flex; gap: 20px;">
                  <mat-form-field class="input-section" style="width:25%;">
                    <mat-label>Process Maturity</mat-label>
                    <mat-select [(ngModel)]="originalProjectControlItem.processMaturity" name="processMaturity"
                                disabled="{{isReadOnly(originalProjectControlItem) && !isManager}}">
                      <mat-option [value]="0">None</mat-option>
                      <mat-option [value]="1">ML1: Performed</mat-option>
                      <mat-option [value]="2">ML2: Documented</mat-option>
                      <mat-option [value]="3">ML3: Managed</mat-option>
                      <mat-option [value]="4">ML4: Reviewed</mat-option>
                      <mat-option [value]="5">ML5: Optimized</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:25%;">
                    <mat-label>Value</mat-label>
                    <input matInput name="value" [(ngModel)]="originalProjectControlItem.controlItem.value"
                           [disabled]="true">
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:25%;">
                    <mat-label>Deduction</mat-label>
                    <input matInput type="number" min="0" [max]="originalProjectControlItem.controlItem.value"
                           name="score" [(ngModel)]="originalProjectControlItem.score"
                           [disabled]="isReadOnly(originalProjectControlItem) && !isManager">
                  </mat-form-field>
                  <mat-form-field class="input-section" style="width:25%;">
                    <mat-label>Score Note</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10" type="text" name="controlOwner_"
                              [(ngModel)]="originalProjectControlItem.scoreNote" #description="ngModel">
                                                   </textarea>
                  </mat-form-field>
                </div>

                <mat-label (click)="visibility.scoringGuidanceEdit = !visibility.scoringGuidanceEdit"
                           class="summary-Heading" style="color: rgba(0,0,0,.54)">
                  Scoring Guidance <span class="pi"
                                         [ngClass]="{'pi-angle-down': !visibility.scoringGuidanceEdit, 'pi-angle-up': visibility.scoringGuidanceEdit}"></span>
                </mat-label>
                <div class="Summary" *ngIf="visibility.scoringGuidanceEdit"
                     [innerHTML]="addToken(originalProjectControlItem.controlItem.scoringGuidance) | sanitizeHtml"></div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

        </div>
      </mat-tab>
      <mat-tab label="Automation">
        <div class="section">
          <mat-accordion [multi]="true">
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header>
                <mat-panel-title> Evidence Automation</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="sections">
                <p-table styleClass="risk-table-striped" [value]="filteredIntegrations"
                         *ngIf="filteredIntegrations && filteredIntegrations.length > 0" dataKey="id"
                         [tableStyle]="{ 'width': '100%' }">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Integration Name</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Created</th>
                      <th>Updated</th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-integration>
                    <tr>
                      <td>{{ integration.name }}</td>
                      <td>{{ integration.type }}</td>
                      <td>{{ integration.status }}</td>
                      <td>{{ integration.createdDate | date: 'short' }}</td>
                      <td>{{ integration.updatedDate | date: 'short' }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>

            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header>
                <mat-panel-title (click)="resetMappingStates()"> Mapping</mat-panel-title>
              </mat-expansion-panel-header>
              <!-- Mapping -->
              <div style="display: flex; flex-direction: row;">
                <div style="flex:1 1 49%">
                  <p-table *ngIf="originalProjectControlItem.sources && originalProjectControlItem.sources.length"
                           [value]="originalProjectControlItem.sources" #table>

                    <ng-template pTemplate="header">
                      <tr style="white-space: nowrap;font-weight: bold;font-size: 15px;">
                        <th>Source Project Name</th>
                        <th>Source Control Item</th>
                        <th>Priority</th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                      <tr (click)="openLinked(item.fromId)">
                        <td>{{ item.fromProjectName }}</td>
                        <td>{{ item.fromControlItemName }}</td>
                        <td>{{ item.isPrimary ? 'Primary' : 'Secondary' }}</td>
                      </tr>
                      <tr (click)="item.hidden = !item.hidden">
                        <div class="component-detail-btn">
                          <p>Mapping Details</p>
                          <i [ngClass]="item.hidden ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                        </div>
                      </tr>
                      <tr [@expandCollapse]="item.hidden ? 'expanded' : 'collapsed'">
                        <td style="vertical-align: top;">
                          <h3 class="detail-heading">Implementation</h3>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.ics1" disabled></mat-checkbox>
                            <p>ICS1</p>
                            <p *ngIf="item.ics1 && item.ics1Mappedwith" style="margin-left:4px">
                              --{{ item.ics1Mappedwith }}</p>
                          </div>
                          <div class="detail-div" *ngIf="item.noOfIcsSections == 2 || item.noOfIcsSections == 3"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.ics2" disabled></mat-checkbox>
                            <p>ICS2</p>
                            <p *ngIf="item.ics2 && item.ics2Mappedwith" style="margin-left:4px">
                              --{{ item.ics2Mappedwith }}</p>
                          </div>
                          <div class="detail-div" *ngIf="item.noOfIcsSections == 3"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.ics3" disabled></mat-checkbox>
                            <p>ICS3</p>
                            <p *ngIf="item.ics3 && item.ics3Mappedwith" style="margin-left:4px">
                              --{{ item.ics3Mappedwith }}</p>
                          </div>
                          <!-- <div class="detail-div" [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                          <mat-checkbox class="mapping-checkboxes" [checked]="item.implementationControlStatement" disabled></mat-checkbox>
                          <p>Implementation Control Statement</p>   </div> -->
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.controlsTesting"
                                          disabled></mat-checkbox>
                            <p>Controls Testing</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.inheritedControls"
                                          disabled></mat-checkbox>
                            <p>Inherited Controls</p>

                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.gaps" disabled></mat-checkbox>
                            <p>Gaps</p>

                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.workstream"
                                          disabled></mat-checkbox>
                            <p>Workstream</p>

                          </div>

                          <h3 class="detail-heading">Artifacts & Evidence</h3>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.evidence" disabled></mat-checkbox>
                            <p>Evidence</p>

                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.policy" disabled></mat-checkbox>
                            <p>Policy</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.documentation"
                                          disabled></mat-checkbox>
                            <p>Documentation</p>
                          </div>
                        </td>
                        <td style="vertical-align: top;">
                          <h3 class="detail-heading">Assessment</h3>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.intAssessment"
                                          disabled></mat-checkbox>
                            <p>Int Assessment</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.thirdPartySecurity"
                                          disabled></mat-checkbox>
                            <p>3P Security</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.thirdPartyRisk"
                                          disabled></mat-checkbox>
                            <p>3P Risk</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.areaSpecific"
                                          disabled></mat-checkbox>
                            <p>Area Specific</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.scoring" disabled></mat-checkbox>
                            <p>Scoring</p>
                          </div>
                          <h3 class="detail-heading">NIST FedRAMP</h3>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.organizationalParameters"
                                          disabled></mat-checkbox>
                            <p>Organizational Parameters</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.controlOrigination"
                                          disabled></mat-checkbox>
                            <p>Control Origination</p>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
                <div style="flex:1 1 2%"></div>
                <div style="flex:1 1 49%">
                  <p-table *ngIf="originalProjectControlItem.targets && originalProjectControlItem.targets.length"
                           [value]="originalProjectControlItem.targets" #table>

                    <ng-template pTemplate="header">
                      <tr style="white-space: nowrap;font-weight: bold;font-size: 15px;">
                        <th>Target Project Name</th>
                        <th>Target Control Item</th>
                        <th>Priority</th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                      <tr (click)="openLinked(item.toId)">
                        <td>{{ item.toProjectName }}</td>
                        <td>{{ item.toControlItemName }}</td>
                        <td>{{ item.isPrimary ? 'Primary' : 'Secondary' }}</td>
                      </tr>
                      <tr (click)="item.hidden = !item.hidden">
                        <div class="component-detail-btn">
                          <p>Mapping Details</p>
                          <i [ngClass]="item.hidden ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                        </div>
                      </tr>
                      <tr [@expandCollapse]="item.hidden ? 'expanded' : 'collapsed'">
                        <td style="vertical-align: top;">
                          <h3 class="detail-heading">Implementation</h3>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.ics1" disabled></mat-checkbox>
                            <p>ICS1</p>
                            <p *ngIf="item.ics1 && item.ics1Mappedwith" style="margin-left:4px">
                              --{{ item.ics1Mappedwith }}</p>
                          </div>
                          <div class="detail-div" *ngIf="item.noOfIcsSections == 2 || item.noOfIcsSections == 3"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.ics2" disabled></mat-checkbox>
                            <p>ICS2</p>
                            <p *ngIf="item.ics2 && item.ics2Mappedwith" style="margin-left:4px">
                              --{{ item.ics2Mappedwith }}</p>
                          </div>
                          <div class="detail-div" *ngIf="item.noOfIcsSections == 3"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.ics3" disabled></mat-checkbox>
                            <p>ICS3</p>
                            <p *ngIf="item.ics3 && item.ics3Mappedwith" style="margin-left:4px">
                              --{{ item.ics3Mappedwith }}</p>
                          </div>
                          <!-- <div class="detail-div" [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.implementationControlStatement" disabled></mat-checkbox>
                            <p>Implementation Control Statement</p>
                          </div> -->
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.controlsTesting"
                                          disabled></mat-checkbox>
                            <p>Controls Testing</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.inheritedControls"
                                          disabled></mat-checkbox>
                            <p>Inherited Controls</p>

                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.gaps" disabled></mat-checkbox>
                            <p>Gaps</p>

                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.workstream"
                                          disabled></mat-checkbox>
                            <p>Workstream</p>

                          </div>

                          <h3 class="detail-heading">Artifacts & Evidence</h3>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">
                            <mat-checkbox class="mapping-checkboxes" [checked]="item.evidence" disabled></mat-checkbox>
                            <p>Evidence</p>

                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.policy" disabled></mat-checkbox>
                            <p>Policy</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.documentation"
                                          disabled></mat-checkbox>
                            <p>Documentation</p>
                          </div>
                        </td>
                        <td style="vertical-align: top;">
                          <h3 class="detail-heading">Assessment</h3>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.intAssessment"
                                          disabled></mat-checkbox>
                            <p>Int Assessment</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.thirdPartySecurity"
                                          disabled></mat-checkbox>
                            <p>3P Security</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.thirdPartyRisk"
                                          disabled></mat-checkbox>
                            <p>3P Risk</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.areaSpecific"
                                          disabled></mat-checkbox>
                            <p>Area Specific</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.scoring" disabled></mat-checkbox>
                            <p>Scoring</p>
                          </div>
                          <h3 class="detail-heading">NIST FedRAMP</h3>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.organizationalParameters"
                                          disabled></mat-checkbox>
                            <p>Organizational Parameters</p>
                          </div>
                          <div class="detail-div"
                               [ngClass]="{'different-style': item.fromComplianceAreaName !== item.toComplianceAreaName}">

                            <mat-checkbox class="mapping-checkboxes" [checked]="item.controlOrigination"
                                          disabled></mat-checkbox>
                            <p>Control Origination</p>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>

      </mat-tab>

      <mat-tab label="NIST FedRAMP">
        <div class="section">
          <mat-accordion [multi]="true">
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header>
                <mat-panel-title> Organizational Parameters</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="sections" *ngIf="originalProjectControlItem.controlItem.complianceArea.isFedRamp">
                <div style="display: flex; flex-direction: row;">
                  <mat-form-field class="input-section" style="width:50%">
                    <mat-label>Responsible Role</mat-label>
                    <input matInput [(ngModel)]="originalProjectControlItem.responsibleRole">
                  </mat-form-field>
                </div>
                <div *ngIf="organizationalParametersQuestions && organizationalParametersQuestions.length">
                  <div>
                    <mat-label style="font-weight: bold">Organizational Parameters</mat-label>
                  </div>
                  <div style="display: flex; flex-direction: row;" *ngFor="let question of organizationalParametersQuestions, let i = index">
                    <div style="flex:100%">
                      <mat-form-field class="textarea-section" style="width:50%">
                        <mat-label>{{ question }}</mat-label>
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" [(ngModel)]="organizationalParameters[i]">
                          </textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div *ngFor="let subControl of originalProjectControlItem.subItems">
                  <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 16px">
                    <div *ngFor="let question of subControl['organizationalParametersQuestions'], let i = index"
                         style="flex:31%">
                      <mat-form-field class="textarea-section" style="width:100%">
                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                  cdkAutosizeMaxRows="10" type="text" [placeholder]="question" readonly="readonly"
                                  (click)="editSubItem(subControl)"
                                  [(ngModel)]="subControl.organizationalParameters[i]">
                          </textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header>
                <mat-panel-title> Control Origination</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="sections">
                <div *ngIf="originalProjectControlItem.controlItem.complianceArea.isFedRamp">

                  <div *ngIf="controlOriginationQuestions && controlOriginationQuestions.length">
                    <div style="display: flex; flex-direction: row;" *ngFor="let question of controlOriginationQuestions, let i = index">
                      <div style="flex:100%">
                        <mat-checkbox [(ngModel)]="controlOrigination[i]"
                                      *ngIf="i < (controlOriginationQuestions.length - 1) || !controlOriginationSpecialParts">{{ question }}
                        </mat-checkbox>
                        <div *ngIf="i == (controlOriginationQuestions.length - 1) && controlOriginationSpecialParts">
                          <mat-checkbox [(ngModel)]="controlOrigination[i]"></mat-checkbox>
                          <mat-label style="font-weight: bold"
                                     (click)="controlOrigination[controlOrigination.length - 1] = !controlOrigination[controlOrigination.length - 1]; controlOriginationExplanationVisible = controlOriginationExplanationVisible && controlOrigination[controlOrigination.length - 1]">
                            <span style="width:8px;display:inline-block;"></span>{{ controlOriginationSpecialParts[0] }}
                          </mat-label>
                          <mat-label
                            style="font-weight: bold; text-decoration: underline; text-decoration-style: dashed;"
                            (click)="controlOriginationExplanationVisible = true"
                            *ngIf="!controlOriginationExplanationVisible">{{ controlOriginationSpecialParts[1] }}
                          </mat-label>
                          <mat-form-field class="example-full-width" style="display:inline-block;"
                                          *ngIf="controlOriginationExplanationVisible">
                            <mat-label>Explanation</mat-label>
                            <input matInput [(ngModel)]="originalProjectControlItem.controlOriginationExplanation">
                          </mat-form-field>
                          <mat-label style="font-weight: bold"
                                     (click)="controlOrigination[controlOrigination.length - 1] = !controlOrigination[controlOrigination.length - 1]; controlOriginationExplanationVisible = controlOriginationExplanationVisible && controlOrigination[controlOrigination.length - 1]">{{ controlOriginationSpecialParts[2] }}
                          </mat-label>
                          <mat-label
                            style="font-weight: bold; text-decoration: underline; text-decoration-style: dashed;"
                            (click)="controlOriginationExplanationVisible = true"
                            *ngIf="!controlOriginationExplanationVisible && controlOriginationSpecialParts.length == 4">
                            Date
                            of
                            Authorization
                          </mat-label>
                          <mat-form-field class="example-full-width" style="display:inline-block;"
                                          *ngIf="controlOriginationExplanationVisible">
                            <mat-label>Date of Authorization</mat-label>
                            <input matInput [matDatepicker]="controlOriginationExplanationDatePicker"
                                   [(ngModel)]="originalProjectControlItem.controlOriginationExplanationDate"
                                   name="controlOriginationExplanation">
                            <mat-datepicker-toggle matSuffix
                                                   [for]="controlOriginationExplanationDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #controlOriginationExplanationDatePicker></mat-datepicker>
                          </mat-form-field>
                          <mat-label style="font-weight: bold">{{ controlOriginationSpecialParts[3] }}</mat-label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <mat-label style="color: rgba(0,0,0,.54)">
                      Customer Responsibilities<span *ngIf="isCustomerResponsibilityRequired">
                        (required)
                      </span><span class="pi pi-pencil"
                                   (click)="visibility.customerResponsibilitiesEdit = !visibility.customerResponsibilitiesEdit"></span>
                    </mat-label>
                    <div class="Summary" style="margin-top:10px" *ngIf="!visibility.customerResponsibilitiesEdit"
                         [innerHTML]="addToken(originalProjectControlItem.customerResponsibilities) | sanitizeHtml"></div>

                    <p-editor matInput *ngIf="visibility.customerResponsibilitiesEdit" type="text"
                              name="customerResponsibilities"
                              [(ngModel)]="originalProjectControlItem.customerResponsibilities"
                              #description="ngModel" [disabled]="isReadOnly(originalProjectControlItem)">

                      <p-header>
                        <span class="ql-formats">
                          <select class="ql-size">
                            <option value="huge">Heading</option>
                            <option value="large">Subheading</option>
                            <option selected></option>
                            <option value="small">Small</option>
                          </select>
                          <select class="ql-font">
                            <option selected="">Sans Serif</option>
                            <option value="serif">Serif</option>
                            <option value="monospace">Monospace</option>
                          </select>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-bold" aria-label="Bold"></button>
                          <button class="ql-italic" aria-label="Italic"></button>
                          <button class="ql-underline" aria-label="Underline"></button>
                          <button class="ql-strike" aria-label="Strike"></button>
                        </span>
                        <span class="ql-formats">
                          <select class="ql-color">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                          <select class="ql-background">
                            <option selected="selected"></option>
                            <option value="#e60000"></option>
                            <option value="#ff9900"></option>
                            <option value="#ffff00"></option>
                            <option value="#008a00"></option>
                            <option value="#0066cc"></option>
                            <option value="#9933ff"></option>
                            <option value="#ffffff"></option>
                            <option value="#facccc"></option>
                            <option value="#ffebcc"></option>
                            <option value="#ffffcc"></option>
                            <option value="#cce8cc"></option>
                            <option value="#cce0f5"></option>
                            <option value="#ebd6ff"></option>
                            <option value="#bbbbbb"></option>
                            <option value="#f06666"></option>
                            <option value="#ffc266"></option>
                            <option value="#ffff66"></option>
                            <option value="#66b966"></option>
                            <option value="#66a3e0"></option>
                            <option value="#c285ff"></option>
                            <option value="#888888"></option>
                            <option value="#a10000"></option>
                            <option value="#b26b00"></option>
                            <option value="#b2b200"></option>
                            <option value="#006100"></option>
                            <option value="#0047b2"></option>
                            <option value="#6b24b2"></option>
                            <option value="#444444"></option>
                            <option value="#5c0000"></option>
                            <option value="#663d00"></option>
                            <option value="#666600"></option>
                            <option value="#003700"></option>
                            <option value="#002966"></option>
                            <option value="#3d1466"></option>
                          </select> <span class="ql-format-separator"></span>
                        </span>
                        <span class="ql-formats">
                          <button class="ql-list" value="ordered"></button>
                          <button class="ql-list" value="bullet"></button>
                          <select title="Text Alignment" class="ql-align">
                            <option selected>Left</option>
                            <option value="center" label="Center"></option>
                            <option value="right" label="Right"></option>
                            <option value="justify" label="Justify"></option>
                          </select>
                          <button class="ql-indent" value="-1"></button>
                          <button class="ql-indent" value="+1"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Link" class="ql-link"></button>
                          <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;"
                                  #el (click)="selectDocument(el)">
                            D
                          </button>
                          <button aria-label="Image" class="ql-image"></button>
                          <button aria-label="Code block" class="ql-code-block"></button>
                        </span>
                        <span class="ql-formats">
                          <button aria-label="Clean" class="ql-clean"></button>
                        </span>
                      </p-header>
                    </p-editor>
                  </div>
                  <div *ngIf="subItems && subItems.length">
                    <mat-label>What is the solution and how is it implemented?</mat-label>
                    <p-table [value]="subItems">
                      <ng-template pTemplate="header">
                        <tr style="white-space: nowrap;font-weight: bold">
                          <th style="width: 20%">Control ID</th>
                          <th>Implementation Control Statement</th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-item>
                        <tr (click)="editSubItem(item)">
                          <td>
                            {{ item.controlItem.complianceAreaControlId }}
                          </td>
                          <td>
                            <div class="ql-editor" [innerHTML]="item.solutionDescription"></div>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>
                  </div>
                  <div style="display: flex; flex-direction: row;">
                    <div style="display:flex; gap:30px; width:100%">
                      <mat-form-field class="input-section" style="width:50%;">
                        <mat-label>Applicable to System</mat-label>
                        <input matInput [(ngModel)]="originalProjectControlItem.applicableToSystem_">
                      </mat-form-field>
                      <mat-form-field class="input-section" style="width:50%;">
                        <mat-label>Control Type</mat-label>
                        <input matInput [(ngModel)]="originalProjectControlItem.controlType_">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>

          </mat-accordion>
        </div>
      </mat-tab>


    </mat-tab-group>
  </div>
  <alert></alert>
</div>
<div mat-dialog-actions>
  <div class="save-button">
    <button mat-raised-button [disabled]="loading || loadingCounter > 0" (click)="onSave()"
            *ngIf="!originalProjectControlItem.primarySource">
      Save
    </button>
    <button mat-raised-button [disabled]="loading || loadingCounter > 0" mwlConfirmationPopover
            [title]="'Delete Project'"
            [popoverMessage]="'Since this is control is mapped to a core control, your some changes may be overwritten if the source control is changed. Are you sure?'"
            [appendToBody]="true" [confirmText]="'Save'" [cancelText]="'Cancel'" placement="top" (confirm)="onSave()"
            *ngIf="originalProjectControlItem.primarySource">
      Save
    </button>
    <img *ngIf="loading"
         src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
    <button mat-raised-button (click)="onClose(null)" class="cancel-button">Cancel</button>
  </div>
</div>
